import { IQueryTableResult } from "../../services/pilotService/responses/types";
import { QueryType } from "#store/tables/tableTypes";

export const categorical: IQueryTableResult = {
    columns: ["class"],
    type: "table",
    sourceQuery: "SELECT class FROM table LIMIT 683",
    queryType: QueryType.SQL,
    interpretationId: 1,
    tableId: 0,
    data: [
        [" diaporthe-stem-canker"],
        [" diaporthe-stem-canker"],
        [" diaporthe-stem-canker"],
        [" diaporthe-stem-canker"],
        [" diaporthe-stem-canker"],
        [" diaporthe-stem-canker"],
        [" diaporthe-stem-canker"],
        [" diaporthe-stem-canker"],
        [" diaporthe-stem-canker"],
        [" diaporthe-stem-canker"],
        [" charcoal-rot"],
        [" charcoal-rot"],
        [" charcoal-rot"],
        [" charcoal-rot"],
        [" charcoal-rot"],
        [" charcoal-rot"],
        [" charcoal-rot"],
        [" charcoal-rot"],
        [" charcoal-rot"],
        [" charcoal-rot"],
    ],
    meta: {
        descriptors: [
            {
                majorityType: "STRING",
                majorityTypeFraction: 1.0,
                typeDistribution: {
                    STRING: 683,
                },
                valueDescription: {
                    "@type": "categorical",
                    histogram: [
                        {
                            count: 92,
                            label: " brown-spot",
                            from: " brown-spot",
                            to: null,
                        },
                        {
                            count: 91,
                            label: " frog-eye-leaf-spot",
                            from: " frog-eye-leaf-spot",
                            to: null,
                        },
                        {
                            count: 91,
                            label: " alternarialeaf-spot",
                            from: " alternarialeaf-spot",
                            to: null,
                        },
                        {
                            count: 88,
                            label: " phytophthora-rot",
                            from: " phytophthora-rot",
                            to: null,
                        },
                        {
                            count: 44,
                            label: " brown-stem-rot",
                            from: " brown-stem-rot",
                            to: null,
                        },
                        {
                            count: 44,
                            label: " anthracnose",
                            from: " anthracnose",
                            to: null,
                        },
                        {
                            count: 20,
                            label: " bacterial-blight",
                            from: " bacterial-blight",
                            to: null,
                        },
                        {
                            count: 20,
                            label: " purple-seed-stain",
                            from: " purple-seed-stain",
                            to: null,
                        },
                        {
                            count: 20,
                            label: " diaporthe-stem-canker",
                            from: " diaporthe-stem-canker",
                            to: null,
                        },
                        {
                            count: 173,
                            label: "Others",
                            from: " downy-mildew",
                            to: " herbicide-injury",
                        },
                    ],
                    unique: 19,
                },
            },
        ],
        types: ["STRING"],
        weigths: [1.0],
        columns: ["class"],
        classes: [null],
        labels: ["class (STRING)"],
        dateformats: [null],
    },
};

export const credit_approval: IQueryTableResult = {
    sourceQuery: "SELECT * from credit_approval",
    queryType: QueryType.SQL,
    interpretationId: 2,
    tableId: 1,
    columns: [
        "A1",
        "A2",
        "A3",
        "A4",
        "A5",
        "A6",
        "A7",
        "A8",
        "A9",
        "A10",
        "A11",
        "A12",
        "A13",
        "A14",
        "A15",
        "class",
        "__uid",
    ],
    type: "table",
    meta: {
        descriptors: [
            {
                majorityType: "STRING",
                majorityTypeFraction: 1,
                typeDistribution: {
                    STRING: 690,
                },
                valueDescription: {
                    "@type": "categorical",
                    histogram: [
                        {
                            count: 468,
                            label: "b",
                            from: "b",
                            to: null,
                        },
                        {
                            count: 210,
                            label: "a",
                            from: "a",
                            to: null,
                        },
                        {
                            count: 12,
                            label: "?",
                            from: "?",
                            to: null,
                        },
                        {
                            count: 0,
                            label: "Others",
                            from: null,
                            to: null,
                        },
                    ],
                    unique: 3,
                },
            },
            {
                majorityType: "DOUBLE",
                majorityTypeFraction: 0.9826086956521739,
                typeDistribution: {
                    DOUBLE: 678,
                    STRING: 12,
                },
                valueDescription: {
                    "@type": "numerical",
                    histogram: [
                        {
                            count: 88,
                            label: "< 20.0",
                            from: 10,
                            to: 20,
                        },
                        {
                            count: 285,
                            label: "20.0 - 30.0",
                            from: 20,
                            to: 30,
                        },
                        {
                            count: 163,
                            label: "30.0 - 40.0",
                            from: 30,
                            to: 40,
                        },
                        {
                            count: 83,
                            label: "40.0 - 50.0",
                            from: 40,
                            to: 50,
                        },
                        {
                            count: 40,
                            label: "50.0 - 60.0",
                            from: 50,
                            to: 60,
                        },
                        {
                            count: 14,
                            label: "60.0 - 70.0",
                            from: 60,
                            to: 70,
                        },
                        {
                            count: 4,
                            label: "70.0 - 80.0",
                            from: 70,
                            to: 80,
                        },
                        {
                            count: 1,
                            label: "≥ 80.0",
                            from: 80,
                            to: 90,
                        },
                    ],
                },
            },
            {
                majorityType: "DOUBLE",
                majorityTypeFraction: 0.7840579710144927,
                typeDistribution: {
                    DOUBLE: 541,
                    INTEGER: 149,
                },
                valueDescription: {
                    "@type": "numerical",
                    histogram: [
                        {
                            count: 574,
                            label: "< 10.0",
                            from: 0,
                            to: 10,
                        },
                        {
                            count: 107,
                            label: "10.0 - 20.0",
                            from: 10,
                            to: 20,
                        },
                        {
                            count: 9,
                            label: "≥ 20.0",
                            from: 20,
                            to: 30,
                        },
                    ],
                },
            },
            {
                majorityType: "STRING",
                majorityTypeFraction: 1,
                typeDistribution: {
                    STRING: 690,
                },
                valueDescription: {
                    "@type": "categorical",
                    histogram: [
                        {
                            count: 519,
                            label: "u",
                            from: "u",
                            to: null,
                        },
                        {
                            count: 163,
                            label: "y",
                            from: "y",
                            to: null,
                        },
                        {
                            count: 6,
                            label: "?",
                            from: "?",
                            to: null,
                        },
                        {
                            count: 2,
                            label: "l",
                            from: "l",
                            to: null,
                        },
                        {
                            count: 0,
                            label: "Others",
                            from: null,
                            to: null,
                        },
                    ],
                    unique: 4,
                },
            },
            {
                majorityType: "STRING",
                majorityTypeFraction: 1,
                typeDistribution: {
                    STRING: 690,
                },
                valueDescription: {
                    "@type": "categorical",
                    histogram: [
                        {
                            count: 519,
                            label: "g",
                            from: "g",
                            to: null,
                        },
                        {
                            count: 163,
                            label: "p",
                            from: "p",
                            to: null,
                        },
                        {
                            count: 6,
                            label: "?",
                            from: "?",
                            to: null,
                        },
                        {
                            count: 2,
                            label: "gg",
                            from: "gg",
                            to: null,
                        },
                        {
                            count: 0,
                            label: "Others",
                            from: null,
                            to: null,
                        },
                    ],
                    unique: 4,
                },
            },
            {
                majorityType: "STRING",
                majorityTypeFraction: 1,
                typeDistribution: {
                    STRING: 690,
                },
                valueDescription: {
                    "@type": "categorical",
                    histogram: [
                        {
                            count: 137,
                            label: "c",
                            from: "c",
                            to: null,
                        },
                        {
                            count: 78,
                            label: "q",
                            from: "q",
                            to: null,
                        },
                        {
                            count: 64,
                            label: "w",
                            from: "w",
                            to: null,
                        },
                        {
                            count: 59,
                            label: "i",
                            from: "i",
                            to: null,
                        },
                        {
                            count: 352,
                            label: "Others",
                            from: "aa",
                            to: "r",
                        },
                    ],
                    unique: 15,
                },
            },
            {
                majorityType: "STRING",
                majorityTypeFraction: 1,
                typeDistribution: {
                    STRING: 690,
                },
                valueDescription: {
                    "@type": "categorical",
                    histogram: [
                        {
                            count: 399,
                            label: "v",
                            from: "v",
                            to: null,
                        },
                        {
                            count: 138,
                            label: "h",
                            from: "h",
                            to: null,
                        },
                        {
                            count: 59,
                            label: "bb",
                            from: "bb",
                            to: null,
                        },
                        {
                            count: 57,
                            label: "ff",
                            from: "ff",
                            to: null,
                        },
                        {
                            count: 37,
                            label: "Others",
                            from: "?",
                            to: "o",
                        },
                    ],
                    unique: 10,
                },
            },
            {
                majorityType: "DOUBLE",
                majorityTypeFraction: 0.7420289855072464,
                typeDistribution: {
                    DOUBLE: 512,
                    INTEGER: 178,
                },
                valueDescription: {
                    "@type": "numerical",
                    histogram: [
                        {
                            count: 664,
                            label: "< 10.0",
                            from: 0,
                            to: 10,
                        },
                        {
                            count: 25,
                            label: "10.0 - 20.0",
                            from: 10,
                            to: 20,
                        },
                        {
                            count: 1,
                            label: "≥ 20.0",
                            from: 20,
                            to: 30,
                        },
                    ],
                },
            },
            {
                majorityType: "STRING",
                majorityTypeFraction: 1,
                typeDistribution: {
                    STRING: 690,
                },
                valueDescription: {
                    "@type": "categorical",
                    histogram: [
                        {
                            count: 361,
                            label: "t",
                            from: "t",
                            to: null,
                        },
                        {
                            count: 329,
                            label: "f",
                            from: "f",
                            to: null,
                        },
                        {
                            count: 0,
                            label: "Others",
                            from: null,
                            to: null,
                        },
                    ],
                    unique: 2,
                },
            },
            {
                majorityType: "STRING",
                majorityTypeFraction: 1,
                typeDistribution: {
                    STRING: 690,
                },
                valueDescription: {
                    "@type": "categorical",
                    histogram: [
                        {
                            count: 395,
                            label: "f",
                            from: "f",
                            to: null,
                        },
                        {
                            count: 295,
                            label: "t",
                            from: "t",
                            to: null,
                        },
                        {
                            count: 0,
                            label: "Others",
                            from: null,
                            to: null,
                        },
                    ],
                    unique: 2,
                },
            },
            {
                majorityType: "INTEGER",
                majorityTypeFraction: 1,
                typeDistribution: {
                    INTEGER: 690,
                },
                valueDescription: {
                    "@type": "numerical",
                    histogram: [
                        {
                            count: 639,
                            label: "< 10.0",
                            from: 0,
                            to: 10,
                        },
                        {
                            count: 48,
                            label: "10.0 - 20.0",
                            from: 10,
                            to: 20,
                        },
                        {
                            count: 1,
                            label: "20.0 - 30.0",
                            from: 20,
                            to: 30,
                        },
                        {
                            count: 1,
                            label: "30.0 - 40.0",
                            from: 30,
                            to: 40,
                        },
                        {
                            count: 0,
                            label: "40.0 - 50.0",
                            from: 40,
                            to: 50,
                        },
                        {
                            count: 0,
                            label: "50.0 - 60.0",
                            from: 50,
                            to: 60,
                        },
                        {
                            count: 1,
                            label: "≥ 60.0",
                            from: 60,
                            to: 70,
                        },
                    ],
                },
            },
            {
                majorityType: "STRING",
                majorityTypeFraction: 1,
                typeDistribution: {
                    STRING: 690,
                },
                valueDescription: {
                    "@type": "categorical",
                    histogram: [
                        {
                            count: 374,
                            label: "f",
                            from: "f",
                            to: null,
                        },
                        {
                            count: 316,
                            label: "t",
                            from: "t",
                            to: null,
                        },
                        {
                            count: 0,
                            label: "Others",
                            from: null,
                            to: null,
                        },
                    ],
                    unique: 2,
                },
            },
            {
                majorityType: "STRING",
                majorityTypeFraction: 1,
                typeDistribution: {
                    STRING: 690,
                },
                valueDescription: {
                    "@type": "categorical",
                    histogram: [
                        {
                            count: 625,
                            label: "g",
                            from: "g",
                            to: null,
                        },
                        {
                            count: 57,
                            label: "s",
                            from: "s",
                            to: null,
                        },
                        {
                            count: 8,
                            label: "p",
                            from: "p",
                            to: null,
                        },
                        {
                            count: 0,
                            label: "Others",
                            from: null,
                            to: null,
                        },
                    ],
                    unique: 3,
                },
            },
            {
                majorityType: "INTEGER",
                majorityTypeFraction: 0.981159420289855,
                typeDistribution: {
                    INTEGER: 677,
                    STRING: 13,
                },
                valueDescription: {
                    "@type": "numerical",
                    histogram: [
                        {
                            count: 653,
                            label: "< 500.0",
                            from: 0,
                            to: 500,
                        },
                        {
                            count: 22,
                            label: "500.0 - 1000.0",
                            from: 500,
                            to: 1000,
                        },
                        {
                            count: 1,
                            label: "1000.0 - 1500.0",
                            from: 1000,
                            to: 1500,
                        },
                        {
                            count: 1,
                            label: "≥ 1500.0",
                            from: 1500,
                            to: 2000,
                        },
                    ],
                },
            },
            {
                majorityType: "INTEGER",
                majorityTypeFraction: 1,
                typeDistribution: {
                    INTEGER: 690,
                },
                valueDescription: {
                    "@type": "numerical",
                    histogram: [
                        {
                            count: 678,
                            label: "< 10000.0",
                            from: 0,
                            to: 10000,
                        },
                        {
                            count: 7,
                            label: "10000.0 - 20000.0",
                            from: 10000,
                            to: 20000,
                        },
                        {
                            count: 1,
                            label: "20000.0 - 30000.0",
                            from: 20000,
                            to: 30000,
                        },
                        {
                            count: 1,
                            label: "30000.0 - 40000.0",
                            from: 30000,
                            to: 40000,
                        },
                        {
                            count: 1,
                            label: "40000.0 - 50000.0",
                            from: 40000,
                            to: 50000,
                        },
                        {
                            count: 1,
                            label: "50000.0 - 60000.0",
                            from: 50000,
                            to: 60000,
                        },
                        {
                            count: 0,
                            label: "60000.0 - 70000.0",
                            from: 60000,
                            to: 70000,
                        },
                        {
                            count: 0,
                            label: "70000.0 - 80000.0",
                            from: 70000,
                            to: 80000,
                        },
                        {
                            count: 0,
                            label: "80000.0 - 90000.0",
                            from: 80000,
                            to: 90000,
                        },
                        {
                            count: 1,
                            label: "≥ 90000.0",
                            from: 90000,
                            to: 100000,
                        },
                    ],
                },
            },
            {
                majorityType: "STRING",
                majorityTypeFraction: 1,
                typeDistribution: {
                    STRING: 690,
                },
                valueDescription: {
                    "@type": "categorical",
                    histogram: [
                        {
                            count: 383,
                            label: "-",
                            from: "-",
                            to: null,
                        },
                        {
                            count: 307,
                            label: "+",
                            from: "+",
                            to: null,
                        },
                        {
                            count: 0,
                            label: "Others",
                            from: null,
                            to: null,
                        },
                    ],
                    unique: 2,
                },
            },
            {
                majorityType: "INTEGER",
                majorityTypeFraction: 1,
                typeDistribution: {
                    INTEGER: 690,
                },
                valueDescription: {
                    "@type": "numerical",
                    histogram: [
                        {
                            count: 28,
                            label: "< 832800.0",
                            from: 832700,
                            to: 832800,
                        },
                        {
                            count: 100,
                            label: "832800.0 - 832900.0",
                            from: 832800,
                            to: 832900,
                        },
                        {
                            count: 100,
                            label: "832900.0 - 833000.0",
                            from: 832900,
                            to: 833000,
                        },
                        {
                            count: 100,
                            label: "833000.0 - 833100.0",
                            from: 833000,
                            to: 833100,
                        },
                        {
                            count: 100,
                            label: "833100.0 - 833200.0",
                            from: 833100,
                            to: 833200,
                        },
                        {
                            count: 100,
                            label: "833200.0 - 833300.0",
                            from: 833200,
                            to: 833300,
                        },
                        {
                            count: 100,
                            label: "833300.0 - 833400.0",
                            from: 833300,
                            to: 833400,
                        },
                        {
                            count: 62,
                            label: "≥ 833400.0",
                            from: 833400,
                            to: 833500,
                        },
                    ],
                },
            },
        ],
        types: [
            "STRING",
            "DOUBLE",
            "DOUBLE",
            "STRING",
            "STRING",
            "STRING",
            "STRING",
            "DOUBLE",
            "STRING",
            "STRING",
            "INTEGER",
            "STRING",
            "STRING",
            "INTEGER",
            "INTEGER",
            "STRING",
            "INTEGER",
        ],
        weigths: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        columns: [
            "A1",
            "A2",
            "A3",
            "A4",
            "A5",
            "A6",
            "A7",
            "A8",
            "A9",
            "A10",
            "A11",
            "A12",
            "A13",
            "A14",
            "A15",
            "class",
            "__uid",
        ],
        classes: [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
        ],
        labels: [
            "A1 (STRING)",
            "A2 (DOUBLE)",
            "A3 (DOUBLE)",
            "A4 (STRING)",
            "A5 (STRING)",
            "A6 (STRING)",
            "A7 (STRING)",
            "A8 (DOUBLE)",
            "A9 (STRING)",
            "A10 (STRING)",
            "A11 (INTEGER)",
            "A12 (STRING)",
            "A13 (STRING)",
            "A14 (INTEGER)",
            "A15 (INTEGER)",
            "class (STRING)",
            "__uid (INTEGER)",
        ],
        dateformats: [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
        ],
    },
    data: [
        [
            "b",
            30.83,
            0,
            "u",
            "g",
            "w",
            "v",
            1.25,
            "t",
            "t",
            1,
            "f",
            "g",
            202,
            0,
            "+",
            832773,
        ],
        [
            "a",
            58.67,
            4.46,
            "u",
            "g",
            "q",
            "h",
            3.04,
            "t",
            "t",
            6,
            "f",
            "g",
            43,
            560,
            "+",
            832774,
        ],
        [
            "a",
            24.5,
            0.5,
            "u",
            "g",
            "q",
            "h",
            1.5,
            "t",
            "f",
            0,
            "f",
            "g",
            280,
            824,
            "+",
            832775,
        ],
        [
            "b",
            27.83,
            1.54,
            "u",
            "g",
            "w",
            "v",
            3.75,
            "t",
            "t",
            5,
            "t",
            "g",
            100,
            3,
            "+",
            832776,
        ],
        [
            "b",
            20.17,
            5.625,
            "u",
            "g",
            "w",
            "v",
            1.71,
            "t",
            "f",
            0,
            "f",
            "s",
            120,
            0,
            "+",
            832777,
        ],
        [
            "b",
            32.08,
            4,
            "u",
            "g",
            "m",
            "v",
            2.5,
            "t",
            "f",
            0,
            "t",
            "g",
            360,
            0,
            "+",
            832778,
        ],
        [
            "b",
            33.17,
            1.04,
            "u",
            "g",
            "r",
            "h",
            6.5,
            "t",
            "f",
            0,
            "t",
            "g",
            164,
            31285,
            "+",
            832779,
        ],
        [
            "a",
            22.92,
            11.585,
            "u",
            "g",
            "cc",
            "v",
            0.04,
            "t",
            "f",
            0,
            "f",
            "g",
            80,
            1349,
            "+",
            832780,
        ],
        [
            "b",
            54.42,
            0.5,
            "y",
            "p",
            "k",
            "h",
            3.96,
            "t",
            "f",
            0,
            "f",
            "g",
            180,
            314,
            "+",
            832781,
        ],
        [
            "b",
            42.5,
            4.915,
            "y",
            "p",
            "w",
            "v",
            3.165,
            "t",
            "f",
            0,
            "t",
            "g",
            52,
            1442,
            "+",
            832782,
        ],
        [
            "b",
            22.08,
            0.83,
            "u",
            "g",
            "c",
            "h",
            2.165,
            "f",
            "f",
            0,
            "t",
            "g",
            128,
            0,
            "+",
            832783,
        ],
        [
            "b",
            29.92,
            1.835,
            "u",
            "g",
            "c",
            "h",
            4.335,
            "t",
            "f",
            0,
            "f",
            "g",
            260,
            200,
            "+",
            832784,
        ],
        [
            "a",
            38.25,
            6,
            "u",
            "g",
            "k",
            "v",
            1,
            "t",
            "f",
            0,
            "t",
            "g",
            0,
            0,
            "+",
            832785,
        ],
        [
            "b",
            48.08,
            6.04,
            "u",
            "g",
            "k",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            2690,
            "+",
            832786,
        ],
        [
            "a",
            45.83,
            10.5,
            "u",
            "g",
            "q",
            "v",
            5,
            "t",
            "t",
            7,
            "t",
            "g",
            0,
            0,
            "+",
            832787,
        ],
        [
            "b",
            36.67,
            4.415,
            "y",
            "p",
            "k",
            "v",
            0.25,
            "t",
            "t",
            10,
            "t",
            "g",
            320,
            0,
            "+",
            832788,
        ],
        [
            "b",
            28.25,
            0.875,
            "u",
            "g",
            "m",
            "v",
            0.96,
            "t",
            "t",
            3,
            "t",
            "g",
            396,
            0,
            "+",
            832789,
        ],
        [
            "a",
            23.25,
            5.875,
            "u",
            "g",
            "q",
            "v",
            3.17,
            "t",
            "t",
            10,
            "f",
            "g",
            120,
            245,
            "+",
            832790,
        ],
        [
            "b",
            21.83,
            0.25,
            "u",
            "g",
            "d",
            "h",
            0.665,
            "t",
            "f",
            0,
            "t",
            "g",
            0,
            0,
            "+",
            832791,
        ],
        [
            "a",
            19.17,
            8.585,
            "u",
            "g",
            "cc",
            "h",
            0.75,
            "t",
            "t",
            7,
            "f",
            "g",
            96,
            0,
            "+",
            832792,
        ],
        [
            "b",
            25,
            11.25,
            "u",
            "g",
            "c",
            "v",
            2.5,
            "t",
            "t",
            17,
            "f",
            "g",
            200,
            1208,
            "+",
            832793,
        ],
        [
            "b",
            23.25,
            1,
            "u",
            "g",
            "c",
            "v",
            0.835,
            "t",
            "f",
            0,
            "f",
            "s",
            300,
            0,
            "+",
            832794,
        ],
        [
            "a",
            47.75,
            8,
            "u",
            "g",
            "c",
            "v",
            7.875,
            "t",
            "t",
            6,
            "t",
            "g",
            0,
            1260,
            "+",
            832795,
        ],
        [
            "a",
            27.42,
            14.5,
            "u",
            "g",
            "x",
            "h",
            3.085,
            "t",
            "t",
            1,
            "f",
            "g",
            120,
            11,
            "+",
            832796,
        ],
        [
            "a",
            41.17,
            6.5,
            "u",
            "g",
            "q",
            "v",
            0.5,
            "t",
            "t",
            3,
            "t",
            "g",
            145,
            0,
            "+",
            832797,
        ],
        [
            "a",
            15.83,
            0.585,
            "u",
            "g",
            "c",
            "h",
            1.5,
            "t",
            "t",
            2,
            "f",
            "g",
            100,
            0,
            "+",
            832798,
        ],
        [
            "a",
            47,
            13,
            "u",
            "g",
            "i",
            "bb",
            5.165,
            "t",
            "t",
            9,
            "t",
            "g",
            0,
            0,
            "+",
            832799,
        ],
        [
            "b",
            56.58,
            18.5,
            "u",
            "g",
            "d",
            "bb",
            15,
            "t",
            "t",
            17,
            "t",
            "g",
            0,
            0,
            "+",
            832800,
        ],
        [
            "b",
            57.42,
            8.5,
            "u",
            "g",
            "e",
            "h",
            7,
            "t",
            "t",
            3,
            "f",
            "g",
            0,
            0,
            "+",
            832801,
        ],
        [
            "b",
            42.08,
            1.04,
            "u",
            "g",
            "w",
            "v",
            5,
            "t",
            "t",
            6,
            "t",
            "g",
            500,
            10000,
            "+",
            832802,
        ],
        [
            "b",
            29.25,
            14.79,
            "u",
            "g",
            "aa",
            "v",
            5.04,
            "t",
            "t",
            5,
            "t",
            "g",
            168,
            0,
            "+",
            832803,
        ],
        [
            "b",
            42,
            9.79,
            "u",
            "g",
            "x",
            "h",
            7.96,
            "t",
            "t",
            8,
            "f",
            "g",
            0,
            0,
            "+",
            832804,
        ],
        [
            "b",
            49.5,
            7.585,
            "u",
            "g",
            "i",
            "bb",
            7.585,
            "t",
            "t",
            15,
            "t",
            "g",
            0,
            5000,
            "+",
            832805,
        ],
        [
            "a",
            36.75,
            5.125,
            "u",
            "g",
            "e",
            "v",
            5,
            "t",
            "f",
            0,
            "t",
            "g",
            0,
            4000,
            "+",
            832806,
        ],
        [
            "a",
            22.58,
            10.75,
            "u",
            "g",
            "q",
            "v",
            0.415,
            "t",
            "t",
            5,
            "t",
            "g",
            0,
            560,
            "+",
            832807,
        ],
        [
            "b",
            27.83,
            1.5,
            "u",
            "g",
            "w",
            "v",
            2,
            "t",
            "t",
            11,
            "t",
            "g",
            434,
            35,
            "+",
            832808,
        ],
        [
            "b",
            27.25,
            1.585,
            "u",
            "g",
            "cc",
            "h",
            1.835,
            "t",
            "t",
            12,
            "t",
            "g",
            583,
            713,
            "+",
            832809,
        ],
        [
            "a",
            23,
            11.75,
            "u",
            "g",
            "x",
            "h",
            0.5,
            "t",
            "t",
            2,
            "t",
            "g",
            300,
            551,
            "+",
            832810,
        ],
        [
            "b",
            27.75,
            0.585,
            "y",
            "p",
            "cc",
            "v",
            0.25,
            "t",
            "t",
            2,
            "f",
            "g",
            260,
            500,
            "+",
            832811,
        ],
        [
            "b",
            54.58,
            9.415,
            "u",
            "g",
            "ff",
            "ff",
            14.415,
            "t",
            "t",
            11,
            "t",
            "g",
            30,
            300,
            "+",
            832812,
        ],
        [
            "b",
            34.17,
            9.17,
            "u",
            "g",
            "c",
            "v",
            4.5,
            "t",
            "t",
            12,
            "t",
            "g",
            0,
            221,
            "+",
            832813,
        ],
        [
            "b",
            28.92,
            15,
            "u",
            "g",
            "c",
            "h",
            5.335,
            "t",
            "t",
            11,
            "f",
            "g",
            0,
            2283,
            "+",
            832814,
        ],
        [
            "b",
            29.67,
            1.415,
            "u",
            "g",
            "w",
            "h",
            0.75,
            "t",
            "t",
            1,
            "f",
            "g",
            240,
            100,
            "+",
            832815,
        ],
        [
            "b",
            39.58,
            13.915,
            "u",
            "g",
            "w",
            "v",
            8.625,
            "t",
            "t",
            6,
            "t",
            "g",
            70,
            0,
            "+",
            832816,
        ],
        [
            "b",
            56.42,
            28,
            "y",
            "p",
            "c",
            "v",
            28.5,
            "t",
            "t",
            40,
            "f",
            "g",
            0,
            15,
            "+",
            832817,
        ],
        [
            "b",
            54.33,
            6.75,
            "u",
            "g",
            "c",
            "h",
            2.625,
            "t",
            "t",
            11,
            "t",
            "g",
            0,
            284,
            "+",
            832818,
        ],
        [
            "a",
            41,
            2.04,
            "y",
            "p",
            "q",
            "h",
            0.125,
            "t",
            "t",
            23,
            "t",
            "g",
            455,
            1236,
            "+",
            832819,
        ],
        [
            "b",
            31.92,
            4.46,
            "u",
            "g",
            "cc",
            "h",
            6.04,
            "t",
            "t",
            3,
            "f",
            "g",
            311,
            300,
            "+",
            832820,
        ],
        [
            "b",
            41.5,
            1.54,
            "u",
            "g",
            "i",
            "bb",
            3.5,
            "f",
            "f",
            0,
            "f",
            "g",
            216,
            0,
            "+",
            832821,
        ],
        [
            "b",
            23.92,
            0.665,
            "u",
            "g",
            "c",
            "v",
            0.165,
            "f",
            "f",
            0,
            "f",
            "g",
            100,
            0,
            "+",
            832822,
        ],
        [
            "a",
            25.75,
            0.5,
            "u",
            "g",
            "c",
            "h",
            0.875,
            "t",
            "f",
            0,
            "t",
            "g",
            491,
            0,
            "+",
            832823,
        ],
        [
            "b",
            26,
            1,
            "u",
            "g",
            "q",
            "v",
            1.75,
            "t",
            "f",
            0,
            "t",
            "g",
            280,
            0,
            "+",
            832824,
        ],
        [
            "b",
            37.42,
            2.04,
            "u",
            "g",
            "w",
            "v",
            0.04,
            "t",
            "f",
            0,
            "t",
            "g",
            400,
            5800,
            "+",
            832825,
        ],
        [
            "b",
            34.92,
            2.5,
            "u",
            "g",
            "w",
            "v",
            0,
            "t",
            "f",
            0,
            "t",
            "g",
            239,
            200,
            "+",
            832826,
        ],
        [
            "b",
            34.25,
            3,
            "u",
            "g",
            "cc",
            "h",
            7.415,
            "t",
            "f",
            0,
            "t",
            "g",
            0,
            0,
            "+",
            832827,
        ],
        [
            "b",
            23.33,
            11.625,
            "y",
            "p",
            "w",
            "v",
            0.835,
            "t",
            "f",
            0,
            "t",
            "g",
            160,
            300,
            "+",
            832828,
        ],
        [
            "b",
            23.17,
            0,
            "u",
            "g",
            "cc",
            "v",
            0.085,
            "t",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "+",
            832829,
        ],
        [
            "b",
            44.33,
            0.5,
            "u",
            "g",
            "i",
            "h",
            5,
            "t",
            "f",
            0,
            "t",
            "g",
            320,
            0,
            "+",
            832830,
        ],
        [
            "b",
            35.17,
            4.5,
            "u",
            "g",
            "x",
            "h",
            5.75,
            "f",
            "f",
            0,
            "t",
            "s",
            711,
            0,
            "+",
            832831,
        ],
        [
            "b",
            43.25,
            3,
            "u",
            "g",
            "q",
            "h",
            6,
            "t",
            "t",
            11,
            "f",
            "g",
            80,
            0,
            "+",
            832832,
        ],
        [
            "b",
            56.75,
            12.25,
            "u",
            "g",
            "m",
            "v",
            1.25,
            "t",
            "t",
            4,
            "t",
            "g",
            200,
            0,
            "+",
            832833,
        ],
        [
            "b",
            31.67,
            16.165,
            "u",
            "g",
            "d",
            "v",
            3,
            "t",
            "t",
            9,
            "f",
            "g",
            250,
            730,
            "+",
            832834,
        ],
        [
            "a",
            23.42,
            0.79,
            "y",
            "p",
            "q",
            "v",
            1.5,
            "t",
            "t",
            2,
            "t",
            "g",
            80,
            400,
            "+",
            832835,
        ],
        [
            "a",
            20.42,
            0.835,
            "u",
            "g",
            "q",
            "v",
            1.585,
            "t",
            "t",
            1,
            "f",
            "g",
            0,
            0,
            "+",
            832836,
        ],
        [
            "b",
            26.67,
            4.25,
            "u",
            "g",
            "cc",
            "v",
            4.29,
            "t",
            "t",
            1,
            "t",
            "g",
            120,
            0,
            "+",
            832837,
        ],
        [
            "b",
            34.17,
            1.54,
            "u",
            "g",
            "cc",
            "v",
            1.54,
            "t",
            "t",
            1,
            "t",
            "g",
            520,
            50000,
            "+",
            832838,
        ],
        [
            "a",
            36,
            1,
            "u",
            "g",
            "c",
            "v",
            2,
            "t",
            "t",
            11,
            "f",
            "g",
            0,
            456,
            "+",
            832839,
        ],
        [
            "b",
            25.5,
            0.375,
            "u",
            "g",
            "m",
            "v",
            0.25,
            "t",
            "t",
            3,
            "f",
            "g",
            260,
            15108,
            "+",
            832840,
        ],
        [
            "b",
            19.42,
            6.5,
            "u",
            "g",
            "w",
            "h",
            1.46,
            "t",
            "t",
            7,
            "f",
            "g",
            80,
            2954,
            "+",
            832841,
        ],
        [
            "b",
            35.17,
            25.125,
            "u",
            "g",
            "x",
            "h",
            1.625,
            "t",
            "t",
            1,
            "t",
            "g",
            515,
            500,
            "+",
            832842,
        ],
        [
            "b",
            32.33,
            7.5,
            "u",
            "g",
            "e",
            "bb",
            1.585,
            "t",
            "f",
            0,
            "t",
            "s",
            420,
            0,
            "-",
            832843,
        ],
        [
            "b",
            34.83,
            4,
            "u",
            "g",
            "d",
            "bb",
            12.5,
            "t",
            "f",
            0,
            "t",
            "g",
            "?",
            0,
            "-",
            832844,
        ],
        [
            "a",
            38.58,
            5,
            "u",
            "g",
            "cc",
            "v",
            13.5,
            "t",
            "f",
            0,
            "t",
            "g",
            980,
            0,
            "-",
            832845,
        ],
        [
            "b",
            44.25,
            0.5,
            "u",
            "g",
            "m",
            "v",
            10.75,
            "t",
            "f",
            0,
            "f",
            "s",
            400,
            0,
            "-",
            832846,
        ],
        [
            "b",
            44.83,
            7,
            "y",
            "p",
            "c",
            "v",
            1.625,
            "f",
            "f",
            0,
            "f",
            "g",
            160,
            2,
            "-",
            832847,
        ],
        [
            "b",
            20.67,
            5.29,
            "u",
            "g",
            "q",
            "v",
            0.375,
            "t",
            "t",
            1,
            "f",
            "g",
            160,
            0,
            "-",
            832848,
        ],
        [
            "b",
            34.08,
            6.5,
            "u",
            "g",
            "aa",
            "v",
            0.125,
            "t",
            "f",
            0,
            "t",
            "g",
            443,
            0,
            "-",
            832849,
        ],
        [
            "a",
            19.17,
            0.585,
            "y",
            "p",
            "aa",
            "v",
            0.585,
            "t",
            "f",
            0,
            "t",
            "g",
            160,
            0,
            "-",
            832850,
        ],
        [
            "b",
            21.67,
            1.165,
            "y",
            "p",
            "k",
            "v",
            2.5,
            "t",
            "t",
            1,
            "f",
            "g",
            180,
            20,
            "-",
            832851,
        ],
        [
            "b",
            21.5,
            9.75,
            "u",
            "g",
            "c",
            "v",
            0.25,
            "t",
            "f",
            0,
            "f",
            "g",
            140,
            0,
            "-",
            832852,
        ],
        [
            "b",
            49.58,
            19,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "t",
            "t",
            1,
            "f",
            "g",
            94,
            0,
            "-",
            832853,
        ],
        [
            "a",
            27.67,
            1.5,
            "u",
            "g",
            "m",
            "v",
            2,
            "t",
            "f",
            0,
            "f",
            "s",
            368,
            0,
            "-",
            832854,
        ],
        [
            "b",
            39.83,
            0.5,
            "u",
            "g",
            "m",
            "v",
            0.25,
            "t",
            "f",
            0,
            "f",
            "s",
            288,
            0,
            "-",
            832855,
        ],
        [
            "a",
            "?",
            3.5,
            "u",
            "g",
            "d",
            "v",
            3,
            "t",
            "f",
            0,
            "t",
            "g",
            300,
            0,
            "-",
            832856,
        ],
        [
            "b",
            27.25,
            0.625,
            "u",
            "g",
            "aa",
            "v",
            0.455,
            "t",
            "f",
            0,
            "t",
            "g",
            200,
            0,
            "-",
            832857,
        ],
        [
            "b",
            37.17,
            4,
            "u",
            "g",
            "c",
            "bb",
            5,
            "t",
            "f",
            0,
            "t",
            "s",
            280,
            0,
            "-",
            832858,
        ],
        [
            "b",
            "?",
            0.375,
            "u",
            "g",
            "d",
            "v",
            0.875,
            "t",
            "f",
            0,
            "t",
            "s",
            928,
            0,
            "-",
            832859,
        ],
        [
            "b",
            25.67,
            2.21,
            "y",
            "p",
            "aa",
            "v",
            4,
            "t",
            "f",
            0,
            "f",
            "g",
            188,
            0,
            "-",
            832860,
        ],
        [
            "b",
            34,
            4.5,
            "u",
            "g",
            "aa",
            "v",
            1,
            "t",
            "f",
            0,
            "t",
            "g",
            240,
            0,
            "-",
            832861,
        ],
        [
            "a",
            49,
            1.5,
            "u",
            "g",
            "j",
            "j",
            0,
            "t",
            "f",
            0,
            "t",
            "g",
            100,
            27,
            "-",
            832862,
        ],
        [
            "b",
            62.5,
            12.75,
            "y",
            "p",
            "c",
            "h",
            5,
            "t",
            "f",
            0,
            "f",
            "g",
            112,
            0,
            "-",
            832863,
        ],
        [
            "b",
            31.42,
            15.5,
            "u",
            "g",
            "c",
            "v",
            0.5,
            "t",
            "f",
            0,
            "f",
            "g",
            120,
            0,
            "-",
            832864,
        ],
        [
            "b",
            "?",
            5,
            "y",
            "p",
            "aa",
            "v",
            8.5,
            "t",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "-",
            832865,
        ],
        [
            "b",
            52.33,
            1.375,
            "y",
            "p",
            "c",
            "h",
            9.46,
            "t",
            "f",
            0,
            "t",
            "g",
            200,
            100,
            "-",
            832866,
        ],
        [
            "b",
            28.75,
            1.5,
            "y",
            "p",
            "c",
            "v",
            1.5,
            "t",
            "f",
            0,
            "t",
            "g",
            0,
            225,
            "-",
            832867,
        ],
        [
            "a",
            28.58,
            3.54,
            "u",
            "g",
            "i",
            "bb",
            0.5,
            "t",
            "f",
            0,
            "t",
            "g",
            171,
            0,
            "-",
            832868,
        ],
        [
            "b",
            23,
            0.625,
            "y",
            "p",
            "aa",
            "v",
            0.125,
            "t",
            "f",
            0,
            "f",
            "g",
            180,
            1,
            "-",
            832869,
        ],
        [
            "b",
            "?",
            0.5,
            "u",
            "g",
            "c",
            "bb",
            0.835,
            "t",
            "f",
            0,
            "t",
            "s",
            320,
            0,
            "-",
            832870,
        ],
        [
            "a",
            22.5,
            11,
            "y",
            "p",
            "q",
            "v",
            3,
            "t",
            "f",
            0,
            "t",
            "g",
            268,
            0,
            "-",
            832871,
        ],
        [
            "a",
            28.5,
            1,
            "u",
            "g",
            "q",
            "v",
            1,
            "t",
            "t",
            2,
            "t",
            "g",
            167,
            500,
            "-",
            832872,
        ],
        [
            "b",
            37.5,
            1.75,
            "y",
            "p",
            "c",
            "bb",
            0.25,
            "t",
            "f",
            0,
            "t",
            "g",
            164,
            400,
            "-",
            832873,
        ],
        [
            "b",
            35.25,
            16.5,
            "y",
            "p",
            "c",
            "v",
            4,
            "t",
            "f",
            0,
            "f",
            "g",
            80,
            0,
            "-",
            832874,
        ],
        [
            "b",
            18.67,
            5,
            "u",
            "g",
            "q",
            "v",
            0.375,
            "t",
            "t",
            2,
            "f",
            "g",
            0,
            38,
            "-",
            832875,
        ],
        [
            "b",
            25,
            12,
            "u",
            "g",
            "k",
            "v",
            2.25,
            "t",
            "t",
            2,
            "t",
            "g",
            120,
            5,
            "-",
            832876,
        ],
        [
            "b",
            27.83,
            4,
            "y",
            "p",
            "i",
            "h",
            5.75,
            "t",
            "t",
            2,
            "t",
            "g",
            75,
            0,
            "-",
            832877,
        ],
        [
            "b",
            54.83,
            15.5,
            "u",
            "g",
            "e",
            "z",
            0,
            "t",
            "t",
            20,
            "f",
            "g",
            152,
            130,
            "-",
            832878,
        ],
        [
            "b",
            28.75,
            1.165,
            "u",
            "g",
            "k",
            "v",
            0.5,
            "t",
            "f",
            0,
            "f",
            "s",
            280,
            0,
            "-",
            832879,
        ],
        [
            "a",
            25,
            11,
            "y",
            "p",
            "aa",
            "v",
            4.5,
            "t",
            "f",
            0,
            "f",
            "g",
            120,
            0,
            "-",
            832880,
        ],
        [
            "b",
            40.92,
            2.25,
            "y",
            "p",
            "x",
            "h",
            10,
            "t",
            "f",
            0,
            "t",
            "g",
            176,
            0,
            "-",
            832881,
        ],
        [
            "a",
            19.75,
            0.75,
            "u",
            "g",
            "c",
            "v",
            0.795,
            "t",
            "t",
            5,
            "t",
            "g",
            140,
            5,
            "-",
            832882,
        ],
        [
            "b",
            29.17,
            3.5,
            "u",
            "g",
            "w",
            "v",
            3.5,
            "t",
            "t",
            3,
            "t",
            "g",
            329,
            0,
            "-",
            832883,
        ],
        [
            "a",
            24.5,
            1.04,
            "y",
            "p",
            "ff",
            "ff",
            0.5,
            "t",
            "t",
            3,
            "f",
            "g",
            180,
            147,
            "-",
            832884,
        ],
        [
            "b",
            24.58,
            12.5,
            "u",
            "g",
            "w",
            "v",
            0.875,
            "t",
            "f",
            0,
            "t",
            "g",
            260,
            0,
            "-",
            832885,
        ],
        [
            "a",
            33.75,
            0.75,
            "u",
            "g",
            "k",
            "bb",
            1,
            "t",
            "t",
            3,
            "t",
            "g",
            212,
            0,
            "-",
            832886,
        ],
        [
            "b",
            20.67,
            1.25,
            "y",
            "p",
            "c",
            "h",
            1.375,
            "t",
            "t",
            3,
            "t",
            "g",
            140,
            210,
            "-",
            832887,
        ],
        [
            "a",
            25.42,
            1.125,
            "u",
            "g",
            "q",
            "v",
            1.29,
            "t",
            "t",
            2,
            "f",
            "g",
            200,
            0,
            "-",
            832888,
        ],
        [
            "b",
            37.75,
            7,
            "u",
            "g",
            "q",
            "h",
            11.5,
            "t",
            "t",
            7,
            "t",
            "g",
            300,
            5,
            "-",
            832889,
        ],
        [
            "b",
            52.5,
            6.5,
            "u",
            "g",
            "k",
            "v",
            6.29,
            "t",
            "t",
            15,
            "f",
            "g",
            0,
            11202,
            "+",
            832890,
        ],
        [
            "b",
            57.83,
            7.04,
            "u",
            "g",
            "m",
            "v",
            14,
            "t",
            "t",
            6,
            "t",
            "g",
            360,
            1332,
            "+",
            832891,
        ],
        [
            "a",
            20.75,
            10.335,
            "u",
            "g",
            "cc",
            "h",
            0.335,
            "t",
            "t",
            1,
            "t",
            "g",
            80,
            50,
            "+",
            832892,
        ],
        [
            "b",
            39.92,
            6.21,
            "u",
            "g",
            "q",
            "v",
            0.04,
            "t",
            "t",
            1,
            "f",
            "g",
            200,
            300,
            "+",
            832893,
        ],
        [
            "b",
            25.67,
            12.5,
            "u",
            "g",
            "cc",
            "v",
            1.21,
            "t",
            "t",
            67,
            "t",
            "g",
            140,
            258,
            "+",
            832894,
        ],
        [
            "a",
            24.75,
            12.5,
            "u",
            "g",
            "aa",
            "v",
            1.5,
            "t",
            "t",
            12,
            "t",
            "g",
            120,
            567,
            "+",
            832895,
        ],
        [
            "a",
            44.17,
            6.665,
            "u",
            "g",
            "q",
            "v",
            7.375,
            "t",
            "t",
            3,
            "t",
            "g",
            0,
            0,
            "+",
            832896,
        ],
        [
            "a",
            23.5,
            9,
            "u",
            "g",
            "q",
            "v",
            8.5,
            "t",
            "t",
            5,
            "t",
            "g",
            120,
            0,
            "+",
            832897,
        ],
        [
            "b",
            34.92,
            5,
            "u",
            "g",
            "x",
            "h",
            7.5,
            "t",
            "t",
            6,
            "t",
            "g",
            0,
            1000,
            "+",
            832898,
        ],
        [
            "b",
            47.67,
            2.5,
            "u",
            "g",
            "m",
            "bb",
            2.5,
            "t",
            "t",
            12,
            "t",
            "g",
            410,
            2510,
            "+",
            832899,
        ],
        [
            "b",
            22.75,
            11,
            "u",
            "g",
            "q",
            "v",
            2.5,
            "t",
            "t",
            7,
            "t",
            "g",
            100,
            809,
            "+",
            832900,
        ],
        [
            "b",
            34.42,
            4.25,
            "u",
            "g",
            "i",
            "bb",
            3.25,
            "t",
            "t",
            2,
            "f",
            "g",
            274,
            610,
            "+",
            832901,
        ],
        [
            "a",
            28.42,
            3.5,
            "u",
            "g",
            "w",
            "v",
            0.835,
            "t",
            "f",
            0,
            "f",
            "s",
            280,
            0,
            "+",
            832902,
        ],
        [
            "b",
            67.75,
            5.5,
            "u",
            "g",
            "e",
            "z",
            13,
            "t",
            "t",
            1,
            "t",
            "g",
            0,
            0,
            "+",
            832903,
        ],
        [
            "b",
            20.42,
            1.835,
            "u",
            "g",
            "c",
            "v",
            2.25,
            "t",
            "t",
            1,
            "f",
            "g",
            100,
            150,
            "+",
            832904,
        ],
        [
            "a",
            47.42,
            8,
            "u",
            "g",
            "e",
            "bb",
            6.5,
            "t",
            "t",
            6,
            "f",
            "g",
            375,
            51100,
            "+",
            832905,
        ],
        [
            "b",
            36.25,
            5,
            "u",
            "g",
            "c",
            "bb",
            2.5,
            "t",
            "t",
            6,
            "f",
            "g",
            0,
            367,
            "+",
            832906,
        ],
        [
            "b",
            32.67,
            5.5,
            "u",
            "g",
            "q",
            "h",
            5.5,
            "t",
            "t",
            12,
            "t",
            "g",
            408,
            1000,
            "+",
            832907,
        ],
        [
            "b",
            48.58,
            6.5,
            "u",
            "g",
            "q",
            "h",
            6,
            "t",
            "f",
            0,
            "t",
            "g",
            350,
            0,
            "+",
            832908,
        ],
        [
            "b",
            39.92,
            0.54,
            "y",
            "p",
            "aa",
            "v",
            0.5,
            "t",
            "t",
            3,
            "f",
            "g",
            200,
            1000,
            "+",
            832909,
        ],
        [
            "b",
            33.58,
            2.75,
            "u",
            "g",
            "m",
            "v",
            4.25,
            "t",
            "t",
            6,
            "f",
            "g",
            204,
            0,
            "+",
            832910,
        ],
        [
            "a",
            18.83,
            9.5,
            "u",
            "g",
            "w",
            "v",
            1.625,
            "t",
            "t",
            6,
            "t",
            "g",
            40,
            600,
            "+",
            832911,
        ],
        [
            "a",
            26.92,
            13.5,
            "u",
            "g",
            "q",
            "h",
            5,
            "t",
            "t",
            2,
            "f",
            "g",
            0,
            5000,
            "+",
            832912,
        ],
        [
            "a",
            31.25,
            3.75,
            "u",
            "g",
            "cc",
            "h",
            0.625,
            "t",
            "t",
            9,
            "t",
            "g",
            181,
            0,
            "+",
            832913,
        ],
        [
            "a",
            56.5,
            16,
            "u",
            "g",
            "j",
            "ff",
            0,
            "t",
            "t",
            15,
            "f",
            "g",
            0,
            247,
            "+",
            832914,
        ],
        [
            "b",
            43,
            0.29,
            "y",
            "p",
            "cc",
            "h",
            1.75,
            "t",
            "t",
            8,
            "f",
            "g",
            100,
            375,
            "+",
            832915,
        ],
        [
            "b",
            22.33,
            11,
            "u",
            "g",
            "w",
            "v",
            2,
            "t",
            "t",
            1,
            "f",
            "g",
            80,
            278,
            "+",
            832916,
        ],
        [
            "b",
            27.25,
            1.665,
            "u",
            "g",
            "cc",
            "h",
            5.085,
            "t",
            "t",
            9,
            "f",
            "g",
            399,
            827,
            "+",
            832917,
        ],
        [
            "b",
            32.83,
            2.5,
            "u",
            "g",
            "cc",
            "h",
            2.75,
            "t",
            "t",
            6,
            "f",
            "g",
            160,
            2072,
            "+",
            832918,
        ],
        [
            "b",
            23.25,
            1.5,
            "u",
            "g",
            "q",
            "v",
            2.375,
            "t",
            "t",
            3,
            "t",
            "g",
            0,
            582,
            "+",
            832919,
        ],
        [
            "a",
            40.33,
            7.54,
            "y",
            "p",
            "q",
            "h",
            8,
            "t",
            "t",
            14,
            "f",
            "g",
            0,
            2300,
            "+",
            832920,
        ],
        [
            "a",
            30.5,
            6.5,
            "u",
            "g",
            "c",
            "bb",
            4,
            "t",
            "t",
            7,
            "t",
            "g",
            0,
            3065,
            "+",
            832921,
        ],
        [
            "a",
            52.83,
            15,
            "u",
            "g",
            "c",
            "v",
            5.5,
            "t",
            "t",
            14,
            "f",
            "g",
            0,
            2200,
            "+",
            832922,
        ],
        [
            "a",
            46.67,
            0.46,
            "u",
            "g",
            "cc",
            "h",
            0.415,
            "t",
            "t",
            11,
            "t",
            "g",
            440,
            6,
            "+",
            832923,
        ],
        [
            "a",
            58.33,
            10,
            "u",
            "g",
            "q",
            "v",
            4,
            "t",
            "t",
            14,
            "f",
            "g",
            0,
            1602,
            "+",
            832924,
        ],
        [
            "b",
            37.33,
            6.5,
            "u",
            "g",
            "m",
            "h",
            4.25,
            "t",
            "t",
            12,
            "t",
            "g",
            93,
            0,
            "+",
            832925,
        ],
        [
            "b",
            23.08,
            2.5,
            "u",
            "g",
            "c",
            "v",
            1.085,
            "t",
            "t",
            11,
            "t",
            "g",
            60,
            2184,
            "+",
            832926,
        ],
        [
            "b",
            32.75,
            1.5,
            "u",
            "g",
            "cc",
            "h",
            5.5,
            "t",
            "t",
            3,
            "t",
            "g",
            0,
            0,
            "+",
            832927,
        ],
        [
            "a",
            21.67,
            11.5,
            "y",
            "p",
            "j",
            "j",
            0,
            "t",
            "t",
            11,
            "t",
            "g",
            0,
            0,
            "+",
            832928,
        ],
        [
            "a",
            28.5,
            3.04,
            "y",
            "p",
            "x",
            "h",
            2.54,
            "t",
            "t",
            1,
            "f",
            "g",
            70,
            0,
            "+",
            832929,
        ],
        [
            "a",
            68.67,
            15,
            "u",
            "g",
            "e",
            "z",
            0,
            "t",
            "t",
            14,
            "f",
            "g",
            0,
            3376,
            "+",
            832930,
        ],
        [
            "b",
            28,
            2,
            "u",
            "g",
            "k",
            "h",
            4.165,
            "t",
            "t",
            2,
            "t",
            "g",
            181,
            0,
            "+",
            832931,
        ],
        [
            "b",
            34.08,
            0.08,
            "y",
            "p",
            "m",
            "bb",
            0.04,
            "t",
            "t",
            1,
            "t",
            "g",
            280,
            2000,
            "+",
            832932,
        ],
        [
            "b",
            27.67,
            2,
            "u",
            "g",
            "x",
            "h",
            1,
            "t",
            "t",
            4,
            "f",
            "g",
            140,
            7544,
            "+",
            832933,
        ],
        [
            "b",
            44,
            2,
            "u",
            "g",
            "m",
            "v",
            1.75,
            "t",
            "t",
            2,
            "t",
            "g",
            0,
            15,
            "+",
            832934,
        ],
        [
            "b",
            25.08,
            1.71,
            "u",
            "g",
            "x",
            "v",
            1.665,
            "t",
            "t",
            1,
            "t",
            "g",
            395,
            20,
            "+",
            832935,
        ],
        [
            "b",
            32,
            1.75,
            "y",
            "p",
            "e",
            "h",
            0.04,
            "t",
            "f",
            0,
            "t",
            "g",
            393,
            0,
            "+",
            832936,
        ],
        [
            "a",
            60.58,
            16.5,
            "u",
            "g",
            "q",
            "v",
            11,
            "t",
            "f",
            0,
            "t",
            "g",
            21,
            10561,
            "+",
            832937,
        ],
        [
            "a",
            40.83,
            10,
            "u",
            "g",
            "q",
            "h",
            1.75,
            "t",
            "f",
            0,
            "f",
            "g",
            29,
            837,
            "+",
            832938,
        ],
        [
            "b",
            19.33,
            9.5,
            "u",
            "g",
            "q",
            "v",
            1,
            "t",
            "f",
            0,
            "t",
            "g",
            60,
            400,
            "+",
            832939,
        ],
        [
            "a",
            32.33,
            0.54,
            "u",
            "g",
            "cc",
            "v",
            0.04,
            "t",
            "f",
            0,
            "f",
            "g",
            440,
            11177,
            "+",
            832940,
        ],
        [
            "b",
            36.67,
            3.25,
            "u",
            "g",
            "q",
            "h",
            9,
            "t",
            "f",
            0,
            "t",
            "g",
            102,
            639,
            "+",
            832941,
        ],
        [
            "b",
            37.5,
            1.125,
            "y",
            "p",
            "d",
            "v",
            1.5,
            "f",
            "f",
            0,
            "t",
            "g",
            431,
            0,
            "+",
            832942,
        ],
        [
            "a",
            25.08,
            2.54,
            "y",
            "p",
            "aa",
            "v",
            0.25,
            "t",
            "f",
            0,
            "t",
            "g",
            370,
            0,
            "+",
            832943,
        ],
        [
            "b",
            41.33,
            0,
            "u",
            "g",
            "c",
            "bb",
            15,
            "t",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "+",
            832944,
        ],
        [
            "b",
            56,
            12.5,
            "u",
            "g",
            "k",
            "h",
            8,
            "t",
            "f",
            0,
            "t",
            "g",
            24,
            2028,
            "+",
            832945,
        ],
        [
            "a",
            49.83,
            13.585,
            "u",
            "g",
            "k",
            "h",
            8.5,
            "t",
            "f",
            0,
            "t",
            "g",
            0,
            0,
            "+",
            832946,
        ],
        [
            "b",
            22.67,
            10.5,
            "u",
            "g",
            "q",
            "h",
            1.335,
            "t",
            "f",
            0,
            "f",
            "g",
            100,
            0,
            "+",
            832947,
        ],
        [
            "b",
            27,
            1.5,
            "y",
            "p",
            "w",
            "v",
            0.375,
            "t",
            "f",
            0,
            "t",
            "g",
            260,
            1065,
            "+",
            832948,
        ],
        [
            "b",
            25,
            12.5,
            "u",
            "g",
            "aa",
            "v",
            3,
            "t",
            "f",
            0,
            "t",
            "s",
            20,
            0,
            "+",
            832949,
        ],
        [
            "a",
            26.08,
            8.665,
            "u",
            "g",
            "aa",
            "v",
            1.415,
            "t",
            "f",
            0,
            "f",
            "g",
            160,
            150,
            "+",
            832950,
        ],
        [
            "a",
            18.42,
            9.25,
            "u",
            "g",
            "q",
            "v",
            1.21,
            "t",
            "t",
            4,
            "f",
            "g",
            60,
            540,
            "+",
            832951,
        ],
        [
            "b",
            20.17,
            8.17,
            "u",
            "g",
            "aa",
            "v",
            1.96,
            "t",
            "t",
            14,
            "f",
            "g",
            60,
            158,
            "+",
            832952,
        ],
        [
            "b",
            47.67,
            0.29,
            "u",
            "g",
            "c",
            "bb",
            15,
            "t",
            "t",
            20,
            "f",
            "g",
            0,
            15000,
            "+",
            832953,
        ],
        [
            "a",
            21.25,
            2.335,
            "u",
            "g",
            "i",
            "bb",
            0.5,
            "t",
            "t",
            4,
            "f",
            "s",
            80,
            0,
            "+",
            832954,
        ],
        [
            "a",
            20.67,
            3,
            "u",
            "g",
            "q",
            "v",
            0.165,
            "t",
            "t",
            3,
            "f",
            "g",
            100,
            6,
            "+",
            832955,
        ],
        [
            "a",
            57.08,
            19.5,
            "u",
            "g",
            "c",
            "v",
            5.5,
            "t",
            "t",
            7,
            "f",
            "g",
            0,
            3000,
            "+",
            832956,
        ],
        [
            "a",
            22.42,
            5.665,
            "u",
            "g",
            "q",
            "v",
            2.585,
            "t",
            "t",
            7,
            "f",
            "g",
            129,
            3257,
            "+",
            832957,
        ],
        [
            "b",
            48.75,
            8.5,
            "u",
            "g",
            "c",
            "h",
            12.5,
            "t",
            "t",
            9,
            "f",
            "g",
            181,
            1655,
            "+",
            832958,
        ],
        [
            "b",
            40,
            6.5,
            "u",
            "g",
            "aa",
            "bb",
            3.5,
            "t",
            "t",
            1,
            "f",
            "g",
            0,
            500,
            "+",
            832959,
        ],
        [
            "b",
            40.58,
            5,
            "u",
            "g",
            "c",
            "v",
            5,
            "t",
            "t",
            7,
            "f",
            "g",
            0,
            3065,
            "+",
            832960,
        ],
        [
            "a",
            28.67,
            1.04,
            "u",
            "g",
            "c",
            "v",
            2.5,
            "t",
            "t",
            5,
            "t",
            "g",
            300,
            1430,
            "+",
            832961,
        ],
        [
            "a",
            33.08,
            4.625,
            "u",
            "g",
            "q",
            "h",
            1.625,
            "t",
            "t",
            2,
            "f",
            "g",
            0,
            0,
            "+",
            832962,
        ],
        [
            "b",
            21.33,
            10.5,
            "u",
            "g",
            "c",
            "v",
            3,
            "t",
            "f",
            0,
            "t",
            "g",
            0,
            0,
            "+",
            832963,
        ],
        [
            "b",
            42,
            0.205,
            "u",
            "g",
            "i",
            "h",
            5.125,
            "t",
            "f",
            0,
            "f",
            "g",
            400,
            0,
            "+",
            832964,
        ],
        [
            "b",
            41.75,
            0.96,
            "u",
            "g",
            "x",
            "v",
            2.5,
            "t",
            "f",
            0,
            "f",
            "g",
            510,
            600,
            "+",
            832965,
        ],
        [
            "b",
            22.67,
            1.585,
            "y",
            "p",
            "w",
            "v",
            3.085,
            "t",
            "t",
            6,
            "f",
            "g",
            80,
            0,
            "+",
            832966,
        ],
        [
            "b",
            34.5,
            4.04,
            "y",
            "p",
            "i",
            "bb",
            8.5,
            "t",
            "t",
            7,
            "t",
            "g",
            195,
            0,
            "+",
            832967,
        ],
        [
            "b",
            28.25,
            5.04,
            "y",
            "p",
            "c",
            "bb",
            1.5,
            "t",
            "t",
            8,
            "t",
            "g",
            144,
            7,
            "+",
            832968,
        ],
        [
            "b",
            33.17,
            3.165,
            "y",
            "p",
            "x",
            "v",
            3.165,
            "t",
            "t",
            3,
            "t",
            "g",
            380,
            0,
            "+",
            832969,
        ],
        [
            "b",
            48.17,
            7.625,
            "u",
            "g",
            "w",
            "h",
            15.5,
            "t",
            "t",
            12,
            "f",
            "g",
            0,
            790,
            "+",
            832970,
        ],
        [
            "b",
            27.58,
            2.04,
            "y",
            "p",
            "aa",
            "v",
            2,
            "t",
            "t",
            3,
            "t",
            "g",
            370,
            560,
            "+",
            832971,
        ],
        [
            "b",
            22.58,
            10.04,
            "u",
            "g",
            "x",
            "v",
            0.04,
            "t",
            "t",
            9,
            "f",
            "g",
            60,
            396,
            "+",
            832972,
        ],
        [
            "a",
            24.08,
            0.5,
            "u",
            "g",
            "q",
            "h",
            1.25,
            "t",
            "t",
            1,
            "f",
            "g",
            0,
            678,
            "+",
            832973,
        ],
        [
            "a",
            41.33,
            1,
            "u",
            "g",
            "i",
            "bb",
            2.25,
            "t",
            "f",
            0,
            "t",
            "g",
            0,
            300,
            "+",
            832974,
        ],
        [
            "b",
            24.83,
            2.75,
            "u",
            "g",
            "c",
            "v",
            2.25,
            "t",
            "t",
            6,
            "f",
            "g",
            "?",
            600,
            "+",
            832975,
        ],
        [
            "a",
            20.75,
            10.25,
            "u",
            "g",
            "q",
            "v",
            0.71,
            "t",
            "t",
            2,
            "t",
            "g",
            49,
            0,
            "+",
            832976,
        ],
        [
            "b",
            36.33,
            2.125,
            "y",
            "p",
            "w",
            "v",
            0.085,
            "t",
            "t",
            1,
            "f",
            "g",
            50,
            1187,
            "+",
            832977,
        ],
        [
            "a",
            35.42,
            12,
            "u",
            "g",
            "q",
            "h",
            14,
            "t",
            "t",
            8,
            "f",
            "g",
            0,
            6590,
            "+",
            832978,
        ],
        [
            "a",
            71.58,
            0,
            "?",
            "?",
            "?",
            "?",
            0,
            "f",
            "f",
            0,
            "f",
            "p",
            "?",
            0,
            "+",
            832979,
        ],
        [
            "b",
            28.67,
            9.335,
            "u",
            "g",
            "q",
            "h",
            5.665,
            "t",
            "t",
            6,
            "f",
            "g",
            381,
            168,
            "+",
            832980,
        ],
        [
            "b",
            35.17,
            2.5,
            "u",
            "g",
            "k",
            "v",
            4.5,
            "t",
            "t",
            7,
            "f",
            "g",
            150,
            1270,
            "+",
            832981,
        ],
        [
            "b",
            39.5,
            4.25,
            "u",
            "g",
            "c",
            "bb",
            6.5,
            "t",
            "t",
            16,
            "f",
            "g",
            117,
            1210,
            "+",
            832982,
        ],
        [
            "b",
            39.33,
            5.875,
            "u",
            "g",
            "cc",
            "h",
            10,
            "t",
            "t",
            14,
            "t",
            "g",
            399,
            0,
            "+",
            832983,
        ],
        [
            "b",
            24.33,
            6.625,
            "y",
            "p",
            "d",
            "v",
            5.5,
            "t",
            "f",
            0,
            "t",
            "s",
            100,
            0,
            "+",
            832984,
        ],
        [
            "b",
            60.08,
            14.5,
            "u",
            "g",
            "ff",
            "ff",
            18,
            "t",
            "t",
            15,
            "t",
            "g",
            0,
            1000,
            "+",
            832985,
        ],
        [
            "b",
            23.08,
            11.5,
            "u",
            "g",
            "i",
            "v",
            3.5,
            "t",
            "t",
            9,
            "f",
            "g",
            56,
            742,
            "+",
            832986,
        ],
        [
            "b",
            26.67,
            2.71,
            "y",
            "p",
            "cc",
            "v",
            5.25,
            "t",
            "t",
            1,
            "f",
            "g",
            211,
            0,
            "+",
            832987,
        ],
        [
            "b",
            48.17,
            3.5,
            "u",
            "g",
            "aa",
            "v",
            3.5,
            "t",
            "f",
            0,
            "f",
            "s",
            230,
            0,
            "+",
            832988,
        ],
        [
            "b",
            41.17,
            4.04,
            "u",
            "g",
            "cc",
            "h",
            7,
            "t",
            "t",
            8,
            "f",
            "g",
            320,
            0,
            "+",
            832989,
        ],
        [
            "b",
            55.92,
            11.5,
            "u",
            "g",
            "ff",
            "ff",
            5,
            "t",
            "t",
            5,
            "f",
            "g",
            0,
            8851,
            "+",
            832990,
        ],
        [
            "b",
            53.92,
            9.625,
            "u",
            "g",
            "e",
            "v",
            8.665,
            "t",
            "t",
            5,
            "f",
            "g",
            0,
            0,
            "+",
            832991,
        ],
        [
            "a",
            18.92,
            9.25,
            "y",
            "p",
            "c",
            "v",
            1,
            "t",
            "t",
            4,
            "t",
            "g",
            80,
            500,
            "+",
            832992,
        ],
        [
            "a",
            50.08,
            12.54,
            "u",
            "g",
            "aa",
            "v",
            2.29,
            "t",
            "t",
            3,
            "t",
            "g",
            156,
            0,
            "+",
            832993,
        ],
        [
            "b",
            65.42,
            11,
            "u",
            "g",
            "e",
            "z",
            20,
            "t",
            "t",
            7,
            "t",
            "g",
            22,
            0,
            "+",
            832994,
        ],
        [
            "a",
            17.58,
            9,
            "u",
            "g",
            "aa",
            "v",
            1.375,
            "t",
            "f",
            0,
            "t",
            "g",
            0,
            0,
            "+",
            832995,
        ],
        [
            "a",
            18.83,
            9.54,
            "u",
            "g",
            "aa",
            "v",
            0.085,
            "t",
            "f",
            0,
            "f",
            "g",
            100,
            0,
            "+",
            832996,
        ],
        [
            "a",
            37.75,
            5.5,
            "u",
            "g",
            "q",
            "v",
            0.125,
            "t",
            "f",
            0,
            "t",
            "g",
            228,
            0,
            "+",
            832997,
        ],
        [
            "b",
            23.25,
            4,
            "u",
            "g",
            "c",
            "bb",
            0.25,
            "t",
            "f",
            0,
            "t",
            "g",
            160,
            0,
            "+",
            832998,
        ],
        [
            "b",
            18.08,
            5.5,
            "u",
            "g",
            "k",
            "v",
            0.5,
            "t",
            "f",
            0,
            "f",
            "g",
            80,
            0,
            "+",
            832999,
        ],
        [
            "a",
            22.5,
            8.46,
            "y",
            "p",
            "x",
            "v",
            2.46,
            "f",
            "f",
            0,
            "f",
            "g",
            164,
            0,
            "+",
            833000,
        ],
        [
            "b",
            19.67,
            0.375,
            "u",
            "g",
            "q",
            "v",
            2,
            "t",
            "t",
            2,
            "t",
            "g",
            80,
            0,
            "+",
            833001,
        ],
        [
            "b",
            22.08,
            11,
            "u",
            "g",
            "cc",
            "v",
            0.665,
            "t",
            "f",
            0,
            "f",
            "g",
            100,
            0,
            "+",
            833002,
        ],
        [
            "b",
            25.17,
            3.5,
            "u",
            "g",
            "cc",
            "v",
            0.625,
            "t",
            "t",
            7,
            "f",
            "g",
            0,
            7059,
            "+",
            833003,
        ],
        [
            "a",
            47.42,
            3,
            "u",
            "g",
            "x",
            "v",
            13.875,
            "t",
            "t",
            2,
            "t",
            "g",
            519,
            1704,
            "+",
            833004,
        ],
        [
            "b",
            33.5,
            1.75,
            "u",
            "g",
            "x",
            "h",
            4.5,
            "t",
            "t",
            4,
            "t",
            "g",
            253,
            857,
            "+",
            833005,
        ],
        [
            "b",
            27.67,
            13.75,
            "u",
            "g",
            "w",
            "v",
            5.75,
            "t",
            "f",
            0,
            "t",
            "g",
            487,
            500,
            "+",
            833006,
        ],
        [
            "a",
            58.42,
            21,
            "u",
            "g",
            "i",
            "bb",
            10,
            "t",
            "t",
            13,
            "f",
            "g",
            0,
            6700,
            "+",
            833007,
        ],
        [
            "a",
            20.67,
            1.835,
            "u",
            "g",
            "q",
            "v",
            2.085,
            "t",
            "t",
            5,
            "f",
            "g",
            220,
            2503,
            "+",
            833008,
        ],
        [
            "b",
            26.17,
            0.25,
            "u",
            "g",
            "i",
            "bb",
            0,
            "t",
            "f",
            0,
            "t",
            "g",
            0,
            0,
            "+",
            833009,
        ],
        [
            "b",
            21.33,
            7.5,
            "u",
            "g",
            "aa",
            "v",
            1.415,
            "t",
            "t",
            1,
            "f",
            "g",
            80,
            9800,
            "+",
            833010,
        ],
        [
            "b",
            42.83,
            4.625,
            "u",
            "g",
            "q",
            "v",
            4.58,
            "t",
            "f",
            0,
            "f",
            "s",
            0,
            0,
            "+",
            833011,
        ],
        [
            "b",
            38.17,
            10.125,
            "u",
            "g",
            "x",
            "v",
            2.5,
            "t",
            "t",
            6,
            "f",
            "g",
            520,
            196,
            "+",
            833012,
        ],
        [
            "b",
            20.5,
            10,
            "y",
            "p",
            "c",
            "v",
            2.5,
            "t",
            "f",
            0,
            "f",
            "s",
            40,
            0,
            "+",
            833013,
        ],
        [
            "b",
            48.25,
            25.085,
            "u",
            "g",
            "w",
            "v",
            1.75,
            "t",
            "t",
            3,
            "f",
            "g",
            120,
            14,
            "+",
            833014,
        ],
        [
            "b",
            28.33,
            5,
            "u",
            "g",
            "w",
            "v",
            11,
            "t",
            "f",
            0,
            "t",
            "g",
            70,
            0,
            "+",
            833015,
        ],
        [
            "a",
            18.75,
            7.5,
            "u",
            "g",
            "q",
            "v",
            2.71,
            "t",
            "t",
            5,
            "f",
            "g",
            "?",
            26726,
            "+",
            833016,
        ],
        [
            "b",
            18.5,
            2,
            "u",
            "g",
            "i",
            "v",
            1.5,
            "t",
            "t",
            2,
            "f",
            "g",
            120,
            300,
            "+",
            833017,
        ],
        [
            "b",
            33.17,
            3.04,
            "y",
            "p",
            "c",
            "h",
            2.04,
            "t",
            "t",
            1,
            "t",
            "g",
            180,
            18027,
            "+",
            833018,
        ],
        [
            "b",
            45,
            8.5,
            "u",
            "g",
            "cc",
            "h",
            14,
            "t",
            "t",
            1,
            "t",
            "g",
            88,
            2000,
            "+",
            833019,
        ],
        [
            "a",
            19.67,
            0.21,
            "u",
            "g",
            "q",
            "h",
            0.29,
            "t",
            "t",
            11,
            "f",
            "g",
            80,
            99,
            "+",
            833020,
        ],
        [
            "?",
            24.5,
            12.75,
            "u",
            "g",
            "c",
            "bb",
            4.75,
            "t",
            "t",
            2,
            "f",
            "g",
            73,
            444,
            "+",
            833021,
        ],
        [
            "b",
            21.83,
            11,
            "u",
            "g",
            "x",
            "v",
            0.29,
            "t",
            "t",
            6,
            "f",
            "g",
            121,
            0,
            "+",
            833022,
        ],
        [
            "b",
            40.25,
            21.5,
            "u",
            "g",
            "e",
            "z",
            20,
            "t",
            "t",
            11,
            "f",
            "g",
            0,
            1200,
            "+",
            833023,
        ],
        [
            "b",
            41.42,
            5,
            "u",
            "g",
            "q",
            "h",
            5,
            "t",
            "t",
            6,
            "t",
            "g",
            470,
            0,
            "+",
            833024,
        ],
        [
            "a",
            17.83,
            11,
            "u",
            "g",
            "x",
            "h",
            1,
            "t",
            "t",
            11,
            "f",
            "g",
            0,
            3000,
            "+",
            833025,
        ],
        [
            "b",
            23.17,
            11.125,
            "u",
            "g",
            "x",
            "h",
            0.46,
            "t",
            "t",
            1,
            "f",
            "g",
            100,
            0,
            "+",
            833026,
        ],
        [
            "b",
            "?",
            0.625,
            "u",
            "g",
            "k",
            "v",
            0.25,
            "f",
            "f",
            0,
            "f",
            "g",
            380,
            2010,
            "-",
            833027,
        ],
        [
            "b",
            18.17,
            10.25,
            "u",
            "g",
            "c",
            "h",
            1.085,
            "f",
            "f",
            0,
            "f",
            "g",
            320,
            13,
            "-",
            833028,
        ],
        [
            "b",
            20,
            11.045,
            "u",
            "g",
            "c",
            "v",
            2,
            "f",
            "f",
            0,
            "t",
            "g",
            136,
            0,
            "-",
            833029,
        ],
        [
            "b",
            20,
            0,
            "u",
            "g",
            "d",
            "v",
            0.5,
            "f",
            "f",
            0,
            "f",
            "g",
            144,
            0,
            "-",
            833030,
        ],
        [
            "a",
            20.75,
            9.54,
            "u",
            "g",
            "i",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            200,
            1000,
            "-",
            833031,
        ],
        [
            "a",
            24.5,
            1.75,
            "y",
            "p",
            "c",
            "v",
            0.165,
            "f",
            "f",
            0,
            "f",
            "g",
            132,
            0,
            "-",
            833032,
        ],
        [
            "b",
            32.75,
            2.335,
            "u",
            "g",
            "d",
            "h",
            5.75,
            "f",
            "f",
            0,
            "t",
            "g",
            292,
            0,
            "-",
            833033,
        ],
        [
            "a",
            52.17,
            0,
            "y",
            "p",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "-",
            833034,
        ],
        [
            "a",
            48.17,
            1.335,
            "u",
            "g",
            "i",
            "o",
            0.335,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            120,
            "-",
            833035,
        ],
        [
            "a",
            20.42,
            10.5,
            "y",
            "p",
            "x",
            "h",
            0,
            "f",
            "f",
            0,
            "t",
            "g",
            154,
            32,
            "-",
            833036,
        ],
        [
            "b",
            50.75,
            0.585,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            145,
            0,
            "-",
            833037,
        ],
        [
            "b",
            17.08,
            0.085,
            "y",
            "p",
            "c",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            140,
            722,
            "-",
            833038,
        ],
        [
            "b",
            18.33,
            1.21,
            "y",
            "p",
            "e",
            "dd",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            100,
            0,
            "-",
            833039,
        ],
        [
            "a",
            32,
            6,
            "u",
            "g",
            "d",
            "v",
            1.25,
            "f",
            "f",
            0,
            "f",
            "g",
            272,
            0,
            "-",
            833040,
        ],
        [
            "b",
            59.67,
            1.54,
            "u",
            "g",
            "q",
            "v",
            0.125,
            "t",
            "f",
            0,
            "t",
            "g",
            260,
            0,
            "+",
            833041,
        ],
        [
            "b",
            18,
            0.165,
            "u",
            "g",
            "q",
            "n",
            0.21,
            "f",
            "f",
            0,
            "f",
            "g",
            200,
            40,
            "+",
            833042,
        ],
        [
            "b",
            37.58,
            0,
            "?",
            "?",
            "?",
            "?",
            0,
            "f",
            "f",
            0,
            "f",
            "p",
            "?",
            0,
            "+",
            833043,
        ],
        [
            "b",
            32.33,
            2.5,
            "u",
            "g",
            "c",
            "v",
            1.25,
            "f",
            "f",
            0,
            "t",
            "g",
            280,
            0,
            "-",
            833044,
        ],
        [
            "b",
            18.08,
            6.75,
            "y",
            "p",
            "m",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            140,
            0,
            "-",
            833045,
        ],
        [
            "b",
            38.25,
            10.125,
            "y",
            "p",
            "k",
            "v",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            160,
            0,
            "-",
            833046,
        ],
        [
            "b",
            30.67,
            2.5,
            "u",
            "g",
            "cc",
            "h",
            2.25,
            "f",
            "f",
            0,
            "t",
            "s",
            340,
            0,
            "-",
            833047,
        ],
        [
            "b",
            18.58,
            5.71,
            "u",
            "g",
            "d",
            "v",
            0.54,
            "f",
            "f",
            0,
            "f",
            "g",
            120,
            0,
            "-",
            833048,
        ],
        [
            "a",
            19.17,
            5.415,
            "u",
            "g",
            "i",
            "h",
            0.29,
            "f",
            "f",
            0,
            "f",
            "g",
            80,
            484,
            "-",
            833049,
        ],
        [
            "a",
            18.17,
            10,
            "y",
            "p",
            "q",
            "h",
            0.165,
            "f",
            "f",
            0,
            "f",
            "g",
            340,
            0,
            "-",
            833050,
        ],
        [
            "b",
            24.58,
            13.5,
            "y",
            "p",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            "?",
            0,
            "-",
            833051,
        ],
        [
            "b",
            16.25,
            0.835,
            "u",
            "g",
            "m",
            "v",
            0.085,
            "t",
            "f",
            0,
            "f",
            "s",
            200,
            0,
            "-",
            833052,
        ],
        [
            "b",
            21.17,
            0.875,
            "y",
            "p",
            "c",
            "h",
            0.25,
            "f",
            "f",
            0,
            "f",
            "g",
            280,
            204,
            "-",
            833053,
        ],
        [
            "b",
            23.92,
            0.585,
            "y",
            "p",
            "cc",
            "h",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            240,
            1,
            "-",
            833054,
        ],
        [
            "b",
            17.67,
            4.46,
            "u",
            "g",
            "c",
            "v",
            0.25,
            "f",
            "f",
            0,
            "f",
            "s",
            80,
            0,
            "-",
            833055,
        ],
        [
            "a",
            16.5,
            1.25,
            "u",
            "g",
            "q",
            "v",
            0.25,
            "f",
            "t",
            1,
            "f",
            "g",
            108,
            98,
            "-",
            833056,
        ],
        [
            "b",
            23.25,
            12.625,
            "u",
            "g",
            "c",
            "v",
            0.125,
            "f",
            "t",
            2,
            "f",
            "g",
            0,
            5552,
            "-",
            833057,
        ],
        [
            "b",
            17.58,
            10,
            "u",
            "g",
            "w",
            "h",
            0.165,
            "f",
            "t",
            1,
            "f",
            "g",
            120,
            1,
            "-",
            833058,
        ],
        [
            "a",
            "?",
            1.5,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "t",
            2,
            "t",
            "g",
            200,
            105,
            "-",
            833059,
        ],
        [
            "b",
            29.5,
            0.58,
            "u",
            "g",
            "w",
            "v",
            0.29,
            "f",
            "t",
            1,
            "f",
            "g",
            340,
            2803,
            "-",
            833060,
        ],
        [
            "b",
            18.83,
            0.415,
            "y",
            "p",
            "c",
            "v",
            0.165,
            "f",
            "t",
            1,
            "f",
            "g",
            200,
            1,
            "-",
            833061,
        ],
        [
            "a",
            21.75,
            1.75,
            "y",
            "p",
            "j",
            "j",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            160,
            0,
            "-",
            833062,
        ],
        [
            "b",
            23,
            0.75,
            "u",
            "g",
            "m",
            "v",
            0.5,
            "f",
            "f",
            0,
            "t",
            "s",
            320,
            0,
            "-",
            833063,
        ],
        [
            "a",
            18.25,
            10,
            "u",
            "g",
            "w",
            "v",
            1,
            "f",
            "t",
            1,
            "f",
            "g",
            120,
            1,
            "-",
            833064,
        ],
        [
            "b",
            25.42,
            0.54,
            "u",
            "g",
            "w",
            "v",
            0.165,
            "f",
            "t",
            1,
            "f",
            "g",
            272,
            444,
            "-",
            833065,
        ],
        [
            "b",
            35.75,
            2.415,
            "u",
            "g",
            "w",
            "v",
            0.125,
            "f",
            "t",
            2,
            "f",
            "g",
            220,
            1,
            "-",
            833066,
        ],
        [
            "a",
            16.08,
            0.335,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "t",
            1,
            "f",
            "g",
            160,
            126,
            "-",
            833067,
        ],
        [
            "a",
            31.92,
            3.125,
            "u",
            "g",
            "ff",
            "ff",
            3.04,
            "f",
            "t",
            2,
            "t",
            "g",
            200,
            4,
            "-",
            833068,
        ],
        [
            "b",
            69.17,
            9,
            "u",
            "g",
            "ff",
            "ff",
            4,
            "f",
            "t",
            1,
            "f",
            "g",
            70,
            6,
            "-",
            833069,
        ],
        [
            "b",
            32.92,
            2.5,
            "u",
            "g",
            "aa",
            "v",
            1.75,
            "f",
            "t",
            2,
            "t",
            "g",
            720,
            0,
            "-",
            833070,
        ],
        [
            "b",
            16.33,
            2.75,
            "u",
            "g",
            "aa",
            "v",
            0.665,
            "f",
            "t",
            1,
            "f",
            "g",
            80,
            21,
            "-",
            833071,
        ],
        [
            "b",
            22.17,
            12.125,
            "u",
            "g",
            "c",
            "v",
            3.335,
            "f",
            "t",
            2,
            "t",
            "g",
            180,
            173,
            "-",
            833072,
        ],
        [
            "a",
            57.58,
            2,
            "u",
            "g",
            "ff",
            "ff",
            6.5,
            "f",
            "t",
            1,
            "f",
            "g",
            0,
            10,
            "-",
            833073,
        ],
        [
            "b",
            18.25,
            0.165,
            "u",
            "g",
            "d",
            "v",
            0.25,
            "f",
            "f",
            0,
            "t",
            "s",
            280,
            0,
            "-",
            833074,
        ],
        [
            "b",
            23.42,
            1,
            "u",
            "g",
            "c",
            "v",
            0.5,
            "f",
            "f",
            0,
            "t",
            "s",
            280,
            0,
            "-",
            833075,
        ],
        [
            "a",
            15.92,
            2.875,
            "u",
            "g",
            "q",
            "v",
            0.085,
            "f",
            "f",
            0,
            "f",
            "g",
            120,
            0,
            "-",
            833076,
        ],
        [
            "a",
            24.75,
            13.665,
            "u",
            "g",
            "q",
            "h",
            1.5,
            "f",
            "f",
            0,
            "f",
            "g",
            280,
            1,
            "-",
            833077,
        ],
        [
            "b",
            48.75,
            26.335,
            "y",
            "p",
            "ff",
            "ff",
            0,
            "t",
            "f",
            0,
            "t",
            "g",
            0,
            0,
            "-",
            833078,
        ],
        [
            "b",
            23.5,
            2.75,
            "u",
            "g",
            "ff",
            "ff",
            4.5,
            "f",
            "f",
            0,
            "f",
            "g",
            160,
            25,
            "-",
            833079,
        ],
        [
            "b",
            18.58,
            10.29,
            "u",
            "g",
            "ff",
            "ff",
            0.415,
            "f",
            "f",
            0,
            "f",
            "g",
            80,
            0,
            "-",
            833080,
        ],
        [
            "b",
            27.75,
            1.29,
            "u",
            "g",
            "k",
            "h",
            0.25,
            "f",
            "f",
            0,
            "t",
            "s",
            140,
            0,
            "-",
            833081,
        ],
        [
            "a",
            31.75,
            3,
            "y",
            "p",
            "j",
            "j",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            160,
            20,
            "-",
            833082,
        ],
        [
            "a",
            24.83,
            4.5,
            "u",
            "g",
            "w",
            "v",
            1,
            "f",
            "f",
            0,
            "t",
            "g",
            360,
            6,
            "-",
            833083,
        ],
        [
            "b",
            19,
            1.75,
            "y",
            "p",
            "c",
            "v",
            2.335,
            "f",
            "f",
            0,
            "t",
            "g",
            112,
            6,
            "-",
            833084,
        ],
        [
            "a",
            16.33,
            0.21,
            "u",
            "g",
            "aa",
            "v",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            200,
            1,
            "-",
            833085,
        ],
        [
            "a",
            18.58,
            10,
            "u",
            "g",
            "d",
            "v",
            0.415,
            "f",
            "f",
            0,
            "f",
            "g",
            80,
            42,
            "-",
            833086,
        ],
        [
            "b",
            16.25,
            0,
            "y",
            "p",
            "aa",
            "v",
            0.25,
            "f",
            "f",
            0,
            "f",
            "g",
            60,
            0,
            "-",
            833087,
        ],
        [
            "b",
            23,
            0.75,
            "u",
            "g",
            "m",
            "v",
            0.5,
            "t",
            "f",
            0,
            "t",
            "s",
            320,
            0,
            "-",
            833088,
        ],
        [
            "b",
            21.17,
            0.25,
            "y",
            "p",
            "c",
            "h",
            0.25,
            "f",
            "f",
            0,
            "f",
            "g",
            280,
            204,
            "-",
            833089,
        ],
        [
            "b",
            17.5,
            22,
            "l",
            "gg",
            "ff",
            "o",
            0,
            "f",
            "f",
            0,
            "t",
            "p",
            450,
            100000,
            "+",
            833090,
        ],
        [
            "b",
            19.17,
            0,
            "y",
            "p",
            "m",
            "bb",
            0,
            "f",
            "f",
            0,
            "t",
            "s",
            500,
            1,
            "+",
            833091,
        ],
        [
            "b",
            36.75,
            0.125,
            "y",
            "p",
            "c",
            "v",
            1.5,
            "f",
            "f",
            0,
            "t",
            "g",
            232,
            113,
            "+",
            833092,
        ],
        [
            "b",
            21.25,
            1.5,
            "u",
            "g",
            "w",
            "v",
            1.5,
            "f",
            "f",
            0,
            "f",
            "g",
            150,
            8,
            "+",
            833093,
        ],
        [
            "a",
            18.08,
            0.375,
            "l",
            "gg",
            "cc",
            "ff",
            10,
            "f",
            "f",
            0,
            "t",
            "s",
            300,
            0,
            "+",
            833094,
        ],
        [
            "a",
            33.67,
            0.375,
            "u",
            "g",
            "cc",
            "v",
            0.375,
            "f",
            "f",
            0,
            "f",
            "g",
            300,
            44,
            "+",
            833095,
        ],
        [
            "b",
            48.58,
            0.205,
            "y",
            "p",
            "k",
            "v",
            0.25,
            "t",
            "t",
            11,
            "f",
            "g",
            380,
            2732,
            "+",
            833096,
        ],
        [
            "b",
            33.67,
            1.25,
            "u",
            "g",
            "w",
            "v",
            1.165,
            "f",
            "f",
            0,
            "f",
            "g",
            120,
            0,
            "-",
            833097,
        ],
        [
            "a",
            29.5,
            1.085,
            "y",
            "p",
            "x",
            "v",
            1,
            "f",
            "f",
            0,
            "f",
            "g",
            280,
            13,
            "-",
            833098,
        ],
        [
            "b",
            30.17,
            1.085,
            "y",
            "p",
            "c",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            170,
            179,
            "-",
            833099,
        ],
        [
            "?",
            40.83,
            3.5,
            "u",
            "g",
            "i",
            "bb",
            0.5,
            "f",
            "f",
            0,
            "f",
            "s",
            1160,
            0,
            "-",
            833100,
        ],
        [
            "b",
            34.83,
            2.5,
            "y",
            "p",
            "w",
            "v",
            3,
            "f",
            "f",
            0,
            "f",
            "s",
            200,
            0,
            "-",
            833101,
        ],
        [
            "b",
            "?",
            4,
            "y",
            "p",
            "i",
            "v",
            0.085,
            "f",
            "f",
            0,
            "t",
            "g",
            411,
            0,
            "-",
            833102,
        ],
        [
            "b",
            20.42,
            0,
            "?",
            "?",
            "?",
            "?",
            0,
            "f",
            "f",
            0,
            "f",
            "p",
            "?",
            0,
            "-",
            833103,
        ],
        [
            "a",
            33.25,
            2.5,
            "y",
            "p",
            "c",
            "v",
            2.5,
            "f",
            "f",
            0,
            "t",
            "g",
            0,
            2,
            "-",
            833104,
        ],
        [
            "b",
            34.08,
            2.5,
            "u",
            "g",
            "c",
            "v",
            1,
            "f",
            "f",
            0,
            "f",
            "g",
            460,
            16,
            "-",
            833105,
        ],
        [
            "a",
            25.25,
            12.5,
            "u",
            "g",
            "d",
            "v",
            1,
            "f",
            "f",
            0,
            "t",
            "g",
            180,
            1062,
            "-",
            833106,
        ],
        [
            "b",
            34.75,
            2.5,
            "u",
            "g",
            "cc",
            "bb",
            0.5,
            "f",
            "f",
            0,
            "f",
            "g",
            348,
            0,
            "-",
            833107,
        ],
        [
            "b",
            27.67,
            0.75,
            "u",
            "g",
            "q",
            "h",
            0.165,
            "f",
            "f",
            0,
            "t",
            "g",
            220,
            251,
            "-",
            833108,
        ],
        [
            "b",
            47.33,
            6.5,
            "u",
            "g",
            "c",
            "v",
            1,
            "f",
            "f",
            0,
            "t",
            "g",
            0,
            228,
            "-",
            833109,
        ],
        [
            "a",
            34.83,
            1.25,
            "y",
            "p",
            "i",
            "h",
            0.5,
            "f",
            "f",
            0,
            "t",
            "g",
            160,
            0,
            "-",
            833110,
        ],
        [
            "a",
            33.25,
            3,
            "y",
            "p",
            "aa",
            "v",
            2,
            "f",
            "f",
            0,
            "f",
            "g",
            180,
            0,
            "-",
            833111,
        ],
        [
            "b",
            28,
            3,
            "u",
            "g",
            "w",
            "v",
            0.75,
            "f",
            "f",
            0,
            "t",
            "g",
            300,
            67,
            "-",
            833112,
        ],
        [
            "a",
            39.08,
            4,
            "u",
            "g",
            "c",
            "v",
            3,
            "f",
            "f",
            0,
            "f",
            "g",
            480,
            0,
            "-",
            833113,
        ],
        [
            "b",
            42.75,
            4.085,
            "u",
            "g",
            "aa",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            108,
            100,
            "-",
            833114,
        ],
        [
            "b",
            26.92,
            2.25,
            "u",
            "g",
            "i",
            "bb",
            0.5,
            "f",
            "f",
            0,
            "t",
            "g",
            640,
            4000,
            "-",
            833115,
        ],
        [
            "b",
            33.75,
            2.75,
            "u",
            "g",
            "i",
            "bb",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            180,
            0,
            "-",
            833116,
        ],
        [
            "b",
            38.92,
            1.75,
            "u",
            "g",
            "k",
            "v",
            0.5,
            "f",
            "f",
            0,
            "t",
            "g",
            300,
            2,
            "-",
            833117,
        ],
        [
            "b",
            62.75,
            7,
            "u",
            "g",
            "e",
            "z",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            12,
            "-",
            833118,
        ],
        [
            "?",
            32.25,
            1.5,
            "u",
            "g",
            "c",
            "v",
            0.25,
            "f",
            "f",
            0,
            "t",
            "g",
            372,
            122,
            "-",
            833119,
        ],
        [
            "b",
            26.75,
            4.5,
            "y",
            "p",
            "c",
            "bb",
            2.5,
            "f",
            "f",
            0,
            "f",
            "g",
            200,
            1210,
            "-",
            833120,
        ],
        [
            "b",
            63.33,
            0.54,
            "u",
            "g",
            "c",
            "v",
            0.585,
            "t",
            "t",
            3,
            "t",
            "g",
            180,
            0,
            "-",
            833121,
        ],
        [
            "b",
            27.83,
            1.5,
            "u",
            "g",
            "w",
            "v",
            2.25,
            "f",
            "t",
            1,
            "t",
            "g",
            100,
            3,
            "-",
            833122,
        ],
        [
            "a",
            26.17,
            2,
            "u",
            "g",
            "j",
            "j",
            0,
            "f",
            "f",
            0,
            "t",
            "g",
            276,
            1,
            "-",
            833123,
        ],
        [
            "b",
            22.17,
            0.585,
            "y",
            "p",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            100,
            0,
            "-",
            833124,
        ],
        [
            "b",
            22.5,
            11.5,
            "y",
            "p",
            "m",
            "v",
            1.5,
            "f",
            "f",
            0,
            "t",
            "g",
            0,
            4000,
            "-",
            833125,
        ],
        [
            "b",
            30.75,
            1.585,
            "u",
            "g",
            "d",
            "v",
            0.585,
            "f",
            "f",
            0,
            "t",
            "s",
            0,
            0,
            "-",
            833126,
        ],
        [
            "b",
            36.67,
            2,
            "u",
            "g",
            "i",
            "v",
            0.25,
            "f",
            "f",
            0,
            "t",
            "g",
            221,
            0,
            "-",
            833127,
        ],
        [
            "a",
            16,
            0.165,
            "u",
            "g",
            "aa",
            "v",
            1,
            "f",
            "t",
            2,
            "t",
            "g",
            320,
            1,
            "-",
            833128,
        ],
        [
            "b",
            41.17,
            1.335,
            "u",
            "g",
            "d",
            "v",
            0.165,
            "f",
            "f",
            0,
            "f",
            "g",
            168,
            0,
            "-",
            833129,
        ],
        [
            "a",
            19.5,
            0.165,
            "u",
            "g",
            "q",
            "v",
            0.04,
            "f",
            "f",
            0,
            "t",
            "g",
            380,
            0,
            "-",
            833130,
        ],
        [
            "b",
            32.42,
            3,
            "u",
            "g",
            "d",
            "v",
            0.165,
            "f",
            "f",
            0,
            "t",
            "g",
            120,
            0,
            "-",
            833131,
        ],
        [
            "a",
            36.75,
            4.71,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            160,
            0,
            "-",
            833132,
        ],
        [
            "a",
            30.25,
            5.5,
            "u",
            "g",
            "k",
            "v",
            5.5,
            "f",
            "f",
            0,
            "t",
            "s",
            100,
            0,
            "-",
            833133,
        ],
        [
            "b",
            23.08,
            2.5,
            "u",
            "g",
            "ff",
            "ff",
            0.085,
            "f",
            "f",
            0,
            "t",
            "g",
            100,
            4208,
            "-",
            833134,
        ],
        [
            "b",
            26.83,
            0.54,
            "u",
            "g",
            "k",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            100,
            0,
            "-",
            833135,
        ],
        [
            "b",
            16.92,
            0.335,
            "y",
            "p",
            "k",
            "v",
            0.29,
            "f",
            "f",
            0,
            "f",
            "s",
            200,
            0,
            "-",
            833136,
        ],
        [
            "b",
            24.42,
            2,
            "u",
            "g",
            "e",
            "dd",
            0.165,
            "f",
            "t",
            2,
            "f",
            "g",
            320,
            1300,
            "-",
            833137,
        ],
        [
            "b",
            42.83,
            1.25,
            "u",
            "g",
            "m",
            "v",
            13.875,
            "f",
            "t",
            1,
            "t",
            "g",
            352,
            112,
            "-",
            833138,
        ],
        [
            "a",
            22.75,
            6.165,
            "u",
            "g",
            "aa",
            "v",
            0.165,
            "f",
            "f",
            0,
            "f",
            "g",
            220,
            1000,
            "-",
            833139,
        ],
        [
            "b",
            39.42,
            1.71,
            "y",
            "p",
            "m",
            "v",
            0.165,
            "f",
            "f",
            0,
            "f",
            "s",
            400,
            0,
            "-",
            833140,
        ],
        [
            "a",
            23.58,
            11.5,
            "y",
            "p",
            "k",
            "h",
            3,
            "f",
            "f",
            0,
            "t",
            "g",
            20,
            16,
            "-",
            833141,
        ],
        [
            "b",
            21.42,
            0.75,
            "y",
            "p",
            "r",
            "n",
            0.75,
            "f",
            "f",
            0,
            "t",
            "g",
            132,
            2,
            "-",
            833142,
        ],
        [
            "b",
            33,
            2.5,
            "y",
            "p",
            "w",
            "v",
            7,
            "f",
            "f",
            0,
            "t",
            "g",
            280,
            0,
            "-",
            833143,
        ],
        [
            "b",
            26.33,
            13,
            "u",
            "g",
            "e",
            "dd",
            0,
            "f",
            "f",
            0,
            "t",
            "g",
            140,
            1110,
            "-",
            833144,
        ],
        [
            "a",
            45,
            4.585,
            "u",
            "g",
            "k",
            "h",
            1,
            "f",
            "f",
            0,
            "t",
            "s",
            240,
            0,
            "-",
            833145,
        ],
        [
            "b",
            26.25,
            1.54,
            "u",
            "g",
            "w",
            "v",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            100,
            0,
            "-",
            833146,
        ],
        [
            "?",
            28.17,
            0.585,
            "u",
            "g",
            "aa",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            260,
            1004,
            "-",
            833147,
        ],
        [
            "a",
            20.83,
            0.5,
            "y",
            "p",
            "e",
            "dd",
            1,
            "f",
            "f",
            0,
            "f",
            "g",
            260,
            0,
            "-",
            833148,
        ],
        [
            "b",
            28.67,
            14.5,
            "u",
            "g",
            "d",
            "v",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            286,
            "-",
            833149,
        ],
        [
            "b",
            20.67,
            0.835,
            "y",
            "p",
            "c",
            "v",
            2,
            "f",
            "f",
            0,
            "t",
            "s",
            240,
            0,
            "-",
            833150,
        ],
        [
            "b",
            34.42,
            1.335,
            "u",
            "g",
            "i",
            "bb",
            0.125,
            "f",
            "f",
            0,
            "t",
            "g",
            440,
            4500,
            "-",
            833151,
        ],
        [
            "b",
            33.58,
            0.25,
            "u",
            "g",
            "i",
            "bb",
            4,
            "f",
            "f",
            0,
            "t",
            "s",
            420,
            0,
            "-",
            833152,
        ],
        [
            "b",
            43.17,
            5,
            "u",
            "g",
            "i",
            "bb",
            2.25,
            "f",
            "f",
            0,
            "t",
            "g",
            141,
            0,
            "-",
            833153,
        ],
        [
            "a",
            22.67,
            7,
            "u",
            "g",
            "c",
            "v",
            0.165,
            "f",
            "f",
            0,
            "f",
            "g",
            160,
            0,
            "-",
            833154,
        ],
        [
            "a",
            24.33,
            2.5,
            "y",
            "p",
            "i",
            "bb",
            4.5,
            "f",
            "f",
            0,
            "f",
            "g",
            200,
            456,
            "-",
            833155,
        ],
        [
            "a",
            56.83,
            4.25,
            "y",
            "p",
            "ff",
            "ff",
            5,
            "f",
            "f",
            0,
            "t",
            "g",
            0,
            4,
            "-",
            833156,
        ],
        [
            "b",
            22.08,
            11.46,
            "u",
            "g",
            "k",
            "v",
            1.585,
            "f",
            "f",
            0,
            "t",
            "g",
            100,
            1212,
            "-",
            833157,
        ],
        [
            "b",
            34,
            5.5,
            "y",
            "p",
            "c",
            "v",
            1.5,
            "f",
            "f",
            0,
            "t",
            "g",
            60,
            0,
            "-",
            833158,
        ],
        [
            "b",
            22.58,
            1.5,
            "y",
            "p",
            "aa",
            "v",
            0.54,
            "f",
            "f",
            0,
            "t",
            "g",
            120,
            67,
            "-",
            833159,
        ],
        [
            "b",
            21.17,
            0,
            "u",
            "g",
            "c",
            "v",
            0.5,
            "f",
            "f",
            0,
            "t",
            "s",
            0,
            0,
            "-",
            833160,
        ],
        [
            "b",
            26.67,
            14.585,
            "u",
            "g",
            "i",
            "bb",
            0,
            "f",
            "f",
            0,
            "t",
            "g",
            178,
            0,
            "-",
            833161,
        ],
        [
            "b",
            22.92,
            0.17,
            "u",
            "g",
            "m",
            "v",
            0.085,
            "f",
            "f",
            0,
            "f",
            "s",
            0,
            0,
            "-",
            833162,
        ],
        [
            "b",
            15.17,
            7,
            "u",
            "g",
            "e",
            "v",
            1,
            "f",
            "f",
            0,
            "f",
            "g",
            600,
            0,
            "-",
            833163,
        ],
        [
            "b",
            39.92,
            5,
            "u",
            "g",
            "i",
            "bb",
            0.21,
            "f",
            "f",
            0,
            "f",
            "g",
            550,
            0,
            "-",
            833164,
        ],
        [
            "b",
            27.42,
            12.5,
            "u",
            "g",
            "aa",
            "bb",
            0.25,
            "f",
            "f",
            0,
            "t",
            "g",
            720,
            0,
            "-",
            833165,
        ],
        [
            "b",
            24.75,
            0.54,
            "u",
            "g",
            "m",
            "v",
            1,
            "f",
            "f",
            0,
            "t",
            "g",
            120,
            1,
            "-",
            833166,
        ],
        [
            "b",
            41.17,
            1.25,
            "y",
            "p",
            "w",
            "v",
            0.25,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            195,
            "-",
            833167,
        ],
        [
            "a",
            33.08,
            1.625,
            "u",
            "g",
            "d",
            "v",
            0.54,
            "f",
            "f",
            0,
            "t",
            "g",
            0,
            0,
            "-",
            833168,
        ],
        [
            "b",
            29.83,
            2.04,
            "y",
            "p",
            "x",
            "h",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            128,
            1,
            "-",
            833169,
        ],
        [
            "a",
            23.58,
            0.585,
            "y",
            "p",
            "ff",
            "ff",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            120,
            87,
            "-",
            833170,
        ],
        [
            "b",
            26.17,
            12.5,
            "y",
            "p",
            "k",
            "h",
            1.25,
            "f",
            "f",
            0,
            "t",
            "g",
            0,
            17,
            "-",
            833171,
        ],
        [
            "b",
            31,
            2.085,
            "u",
            "g",
            "c",
            "v",
            0.085,
            "f",
            "f",
            0,
            "f",
            "g",
            300,
            0,
            "-",
            833172,
        ],
        [
            "b",
            20.75,
            5.085,
            "y",
            "p",
            "j",
            "v",
            0.29,
            "f",
            "f",
            0,
            "f",
            "g",
            140,
            184,
            "-",
            833173,
        ],
        [
            "b",
            28.92,
            0.375,
            "u",
            "g",
            "c",
            "v",
            0.29,
            "f",
            "f",
            0,
            "f",
            "g",
            220,
            140,
            "-",
            833174,
        ],
        [
            "a",
            51.92,
            6.5,
            "u",
            "g",
            "i",
            "bb",
            3.085,
            "f",
            "f",
            0,
            "t",
            "g",
            73,
            0,
            "-",
            833175,
        ],
        [
            "a",
            22.67,
            0.335,
            "u",
            "g",
            "q",
            "v",
            0.75,
            "f",
            "f",
            0,
            "f",
            "s",
            160,
            0,
            "-",
            833176,
        ],
        [
            "b",
            34,
            5.085,
            "y",
            "p",
            "i",
            "bb",
            1.085,
            "f",
            "f",
            0,
            "t",
            "g",
            480,
            0,
            "-",
            833177,
        ],
        [
            "a",
            69.5,
            6,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "s",
            0,
            0,
            "-",
            833178,
        ],
        [
            "a",
            40.33,
            8.125,
            "y",
            "p",
            "k",
            "v",
            0.165,
            "f",
            "t",
            2,
            "f",
            "g",
            "?",
            18,
            "-",
            833179,
        ],
        [
            "a",
            19.58,
            0.665,
            "y",
            "p",
            "c",
            "v",
            1,
            "f",
            "t",
            1,
            "f",
            "g",
            2000,
            2,
            "-",
            833180,
        ],
        [
            "b",
            16,
            3.125,
            "u",
            "g",
            "w",
            "v",
            0.085,
            "f",
            "t",
            1,
            "f",
            "g",
            0,
            6,
            "-",
            833181,
        ],
        [
            "b",
            17.08,
            0.25,
            "u",
            "g",
            "q",
            "v",
            0.335,
            "f",
            "t",
            4,
            "f",
            "g",
            160,
            8,
            "-",
            833182,
        ],
        [
            "b",
            31.25,
            2.835,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "t",
            5,
            "f",
            "g",
            176,
            146,
            "-",
            833183,
        ],
        [
            "b",
            25.17,
            3,
            "u",
            "g",
            "c",
            "v",
            1.25,
            "f",
            "t",
            1,
            "f",
            "g",
            0,
            22,
            "-",
            833184,
        ],
        [
            "a",
            22.67,
            0.79,
            "u",
            "g",
            "i",
            "v",
            0.085,
            "f",
            "f",
            0,
            "f",
            "g",
            144,
            0,
            "-",
            833185,
        ],
        [
            "b",
            40.58,
            1.5,
            "u",
            "g",
            "i",
            "bb",
            0,
            "f",
            "f",
            0,
            "f",
            "s",
            300,
            0,
            "-",
            833186,
        ],
        [
            "b",
            22.25,
            0.46,
            "u",
            "g",
            "k",
            "v",
            0.125,
            "f",
            "f",
            0,
            "t",
            "g",
            280,
            55,
            "-",
            833187,
        ],
        [
            "a",
            22.25,
            1.25,
            "y",
            "p",
            "ff",
            "ff",
            3.25,
            "f",
            "f",
            0,
            "f",
            "g",
            280,
            0,
            "-",
            833188,
        ],
        [
            "b",
            22.5,
            0.125,
            "y",
            "p",
            "k",
            "v",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            200,
            70,
            "-",
            833189,
        ],
        [
            "b",
            23.58,
            1.79,
            "u",
            "g",
            "c",
            "v",
            0.54,
            "f",
            "f",
            0,
            "t",
            "g",
            136,
            1,
            "-",
            833190,
        ],
        [
            "b",
            38.42,
            0.705,
            "u",
            "g",
            "c",
            "v",
            0.375,
            "f",
            "t",
            2,
            "f",
            "g",
            225,
            500,
            "-",
            833191,
        ],
        [
            "a",
            26.58,
            2.54,
            "y",
            "p",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "t",
            "g",
            180,
            60,
            "-",
            833192,
        ],
        [
            "b",
            35,
            2.5,
            "u",
            "g",
            "i",
            "v",
            1,
            "f",
            "f",
            0,
            "t",
            "g",
            210,
            0,
            "-",
            833193,
        ],
        [
            "b",
            20.42,
            1.085,
            "u",
            "g",
            "q",
            "v",
            1.5,
            "f",
            "f",
            0,
            "f",
            "g",
            108,
            7,
            "-",
            833194,
        ],
        [
            "b",
            29.42,
            1.25,
            "u",
            "g",
            "w",
            "v",
            1.75,
            "f",
            "f",
            0,
            "f",
            "g",
            200,
            0,
            "-",
            833195,
        ],
        [
            "b",
            26.17,
            0.835,
            "u",
            "g",
            "cc",
            "v",
            1.165,
            "f",
            "f",
            0,
            "f",
            "g",
            100,
            0,
            "-",
            833196,
        ],
        [
            "b",
            33.67,
            2.165,
            "u",
            "g",
            "c",
            "v",
            1.5,
            "f",
            "f",
            0,
            "f",
            "p",
            120,
            0,
            "-",
            833197,
        ],
        [
            "b",
            24.58,
            1.25,
            "u",
            "g",
            "c",
            "v",
            0.25,
            "f",
            "f",
            0,
            "f",
            "g",
            110,
            0,
            "-",
            833198,
        ],
        [
            "a",
            27.67,
            2.04,
            "u",
            "g",
            "w",
            "v",
            0.25,
            "f",
            "f",
            0,
            "t",
            "g",
            180,
            50,
            "-",
            833199,
        ],
        [
            "b",
            37.5,
            0.835,
            "u",
            "g",
            "e",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            120,
            5,
            "-",
            833200,
        ],
        [
            "b",
            49.17,
            2.29,
            "u",
            "g",
            "ff",
            "ff",
            0.29,
            "f",
            "f",
            0,
            "f",
            "g",
            200,
            3,
            "-",
            833201,
        ],
        [
            "b",
            33.58,
            0.335,
            "y",
            "p",
            "cc",
            "v",
            0.085,
            "f",
            "f",
            0,
            "f",
            "g",
            180,
            0,
            "-",
            833202,
        ],
        [
            "b",
            51.83,
            3,
            "y",
            "p",
            "ff",
            "ff",
            1.5,
            "f",
            "f",
            0,
            "f",
            "g",
            180,
            4,
            "-",
            833203,
        ],
        [
            "b",
            22.92,
            3.165,
            "y",
            "p",
            "c",
            "v",
            0.165,
            "f",
            "f",
            0,
            "f",
            "g",
            160,
            1058,
            "-",
            833204,
        ],
        [
            "b",
            21.83,
            1.54,
            "u",
            "g",
            "k",
            "v",
            0.085,
            "f",
            "f",
            0,
            "t",
            "g",
            356,
            0,
            "-",
            833205,
        ],
        [
            "b",
            25.25,
            1,
            "u",
            "g",
            "aa",
            "v",
            0.5,
            "f",
            "f",
            0,
            "f",
            "g",
            200,
            0,
            "-",
            833206,
        ],
        [
            "b",
            58.58,
            2.71,
            "u",
            "g",
            "c",
            "v",
            2.415,
            "f",
            "f",
            0,
            "t",
            "g",
            320,
            0,
            "-",
            833207,
        ],
        [
            "b",
            19,
            0,
            "y",
            "p",
            "ff",
            "ff",
            0,
            "f",
            "t",
            4,
            "f",
            "g",
            45,
            1,
            "-",
            833208,
        ],
        [
            "b",
            19.58,
            0.585,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "t",
            3,
            "f",
            "g",
            350,
            769,
            "-",
            833209,
        ],
        [
            "a",
            53.33,
            0.165,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "t",
            "s",
            62,
            27,
            "-",
            833210,
        ],
        [
            "a",
            27.17,
            1.25,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "t",
            1,
            "f",
            "g",
            92,
            300,
            "-",
            833211,
        ],
        [
            "b",
            25.92,
            0.875,
            "u",
            "g",
            "k",
            "v",
            0.375,
            "f",
            "t",
            2,
            "t",
            "g",
            174,
            3,
            "-",
            833212,
        ],
        [
            "b",
            23.08,
            0,
            "u",
            "g",
            "k",
            "v",
            1,
            "f",
            "t",
            11,
            "f",
            "s",
            0,
            0,
            "-",
            833213,
        ],
        [
            "b",
            39.58,
            5,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "t",
            2,
            "f",
            "g",
            17,
            1,
            "-",
            833214,
        ],
        [
            "b",
            30.58,
            2.71,
            "y",
            "p",
            "m",
            "v",
            0.125,
            "f",
            "f",
            0,
            "t",
            "s",
            80,
            0,
            "-",
            833215,
        ],
        [
            "b",
            17.25,
            3,
            "u",
            "g",
            "k",
            "v",
            0.04,
            "f",
            "f",
            0,
            "t",
            "g",
            160,
            40,
            "-",
            833216,
        ],
        [
            "a",
            17.67,
            0,
            "y",
            "p",
            "j",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            86,
            0,
            "-",
            833217,
        ],
        [
            "a",
            "?",
            11.25,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            "?",
            5200,
            "-",
            833218,
        ],
        [
            "b",
            16.5,
            0.125,
            "u",
            "g",
            "c",
            "v",
            0.165,
            "f",
            "f",
            0,
            "f",
            "g",
            132,
            0,
            "-",
            833219,
        ],
        [
            "a",
            27.33,
            1.665,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            340,
            1,
            "-",
            833220,
        ],
        [
            "b",
            31.25,
            1.125,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "t",
            1,
            "f",
            "g",
            96,
            19,
            "-",
            833221,
        ],
        [
            "b",
            20,
            7,
            "u",
            "g",
            "c",
            "v",
            0.5,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "-",
            833222,
        ],
        [
            "b",
            "?",
            3,
            "y",
            "p",
            "i",
            "bb",
            7,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            1,
            "-",
            833223,
        ],
        [
            "b",
            39.5,
            1.625,
            "u",
            "g",
            "c",
            "v",
            1.5,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            316,
            "-",
            833224,
        ],
        [
            "b",
            36.5,
            4.25,
            "u",
            "g",
            "q",
            "v",
            3.5,
            "f",
            "f",
            0,
            "f",
            "g",
            454,
            50,
            "-",
            833225,
        ],
        [
            "?",
            29.75,
            0.665,
            "u",
            "g",
            "w",
            "v",
            0.25,
            "f",
            "f",
            0,
            "t",
            "g",
            300,
            0,
            "-",
            833226,
        ],
        [
            "b",
            52.42,
            1.5,
            "u",
            "g",
            "d",
            "v",
            3.75,
            "f",
            "f",
            0,
            "t",
            "g",
            0,
            350,
            "-",
            833227,
        ],
        [
            "b",
            36.17,
            18.125,
            "u",
            "g",
            "w",
            "v",
            0.085,
            "f",
            "f",
            0,
            "f",
            "g",
            320,
            3552,
            "-",
            833228,
        ],
        [
            "b",
            34.58,
            0,
            "?",
            "?",
            "?",
            "?",
            0,
            "f",
            "f",
            0,
            "f",
            "p",
            "?",
            0,
            "-",
            833229,
        ],
        [
            "b",
            29.67,
            0.75,
            "y",
            "p",
            "c",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            240,
            0,
            "-",
            833230,
        ],
        [
            "b",
            36.17,
            5.5,
            "u",
            "g",
            "i",
            "bb",
            5,
            "f",
            "f",
            0,
            "f",
            "g",
            210,
            687,
            "-",
            833231,
        ],
        [
            "b",
            25.67,
            0.29,
            "y",
            "p",
            "c",
            "v",
            1.5,
            "f",
            "f",
            0,
            "t",
            "g",
            160,
            0,
            "-",
            833232,
        ],
        [
            "a",
            24.5,
            2.415,
            "y",
            "p",
            "c",
            "v",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            120,
            0,
            "-",
            833233,
        ],
        [
            "b",
            24.08,
            0.875,
            "u",
            "g",
            "m",
            "v",
            0.085,
            "f",
            "t",
            4,
            "f",
            "g",
            254,
            1950,
            "-",
            833234,
        ],
        [
            "b",
            21.92,
            0.5,
            "u",
            "g",
            "c",
            "v",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            360,
            0,
            "-",
            833235,
        ],
        [
            "a",
            36.58,
            0.29,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "t",
            10,
            "f",
            "g",
            200,
            18,
            "-",
            833236,
        ],
        [
            "a",
            23,
            1.835,
            "u",
            "g",
            "j",
            "j",
            0,
            "f",
            "t",
            1,
            "f",
            "g",
            200,
            53,
            "-",
            833237,
        ],
        [
            "a",
            27.58,
            3,
            "u",
            "g",
            "m",
            "v",
            2.79,
            "f",
            "t",
            1,
            "t",
            "g",
            280,
            10,
            "-",
            833238,
        ],
        [
            "b",
            31.08,
            3.085,
            "u",
            "g",
            "c",
            "v",
            2.5,
            "f",
            "t",
            2,
            "t",
            "g",
            160,
            41,
            "-",
            833239,
        ],
        [
            "a",
            30.42,
            1.375,
            "u",
            "g",
            "w",
            "h",
            0.04,
            "f",
            "t",
            3,
            "f",
            "g",
            0,
            33,
            "-",
            833240,
        ],
        [
            "b",
            22.08,
            2.335,
            "u",
            "g",
            "k",
            "v",
            0.75,
            "f",
            "f",
            0,
            "f",
            "g",
            180,
            0,
            "-",
            833241,
        ],
        [
            "b",
            16.33,
            4.085,
            "u",
            "g",
            "i",
            "h",
            0.415,
            "f",
            "f",
            0,
            "t",
            "g",
            120,
            0,
            "-",
            833242,
        ],
        [
            "a",
            21.92,
            11.665,
            "u",
            "g",
            "k",
            "h",
            0.085,
            "f",
            "f",
            0,
            "f",
            "g",
            320,
            5,
            "-",
            833243,
        ],
        [
            "b",
            21.08,
            4.125,
            "y",
            "p",
            "i",
            "h",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            140,
            100,
            "-",
            833244,
        ],
        [
            "b",
            17.42,
            6.5,
            "u",
            "g",
            "i",
            "v",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            60,
            100,
            "-",
            833245,
        ],
        [
            "b",
            19.17,
            4,
            "y",
            "p",
            "i",
            "v",
            1,
            "f",
            "f",
            0,
            "t",
            "g",
            360,
            1000,
            "-",
            833246,
        ],
        [
            "b",
            20.67,
            0.415,
            "u",
            "g",
            "c",
            "v",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            44,
            "-",
            833247,
        ],
        [
            "b",
            26.75,
            2,
            "u",
            "g",
            "d",
            "v",
            0.75,
            "f",
            "f",
            0,
            "t",
            "g",
            80,
            0,
            "-",
            833248,
        ],
        [
            "b",
            23.58,
            0.835,
            "u",
            "g",
            "i",
            "h",
            0.085,
            "f",
            "f",
            0,
            "t",
            "g",
            220,
            5,
            "-",
            833249,
        ],
        [
            "b",
            39.17,
            2.5,
            "y",
            "p",
            "i",
            "h",
            10,
            "f",
            "f",
            0,
            "t",
            "s",
            200,
            0,
            "-",
            833250,
        ],
        [
            "b",
            22.75,
            11.5,
            "u",
            "g",
            "i",
            "v",
            0.415,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "-",
            833251,
        ],
        [
            "?",
            26.5,
            2.71,
            "y",
            "p",
            "?",
            "?",
            0.085,
            "f",
            "f",
            0,
            "f",
            "s",
            80,
            0,
            "-",
            833252,
        ],
        [
            "a",
            16.92,
            0.5,
            "u",
            "g",
            "i",
            "v",
            0.165,
            "f",
            "t",
            6,
            "t",
            "g",
            240,
            35,
            "-",
            833253,
        ],
        [
            "b",
            23.5,
            3.165,
            "y",
            "p",
            "k",
            "v",
            0.415,
            "f",
            "t",
            1,
            "t",
            "g",
            280,
            80,
            "-",
            833254,
        ],
        [
            "a",
            17.33,
            9.5,
            "u",
            "g",
            "aa",
            "v",
            1.75,
            "f",
            "t",
            10,
            "t",
            "g",
            0,
            10,
            "-",
            833255,
        ],
        [
            "b",
            23.75,
            0.415,
            "y",
            "p",
            "c",
            "v",
            0.04,
            "f",
            "t",
            2,
            "f",
            "g",
            128,
            6,
            "-",
            833256,
        ],
        [
            "b",
            34.67,
            1.08,
            "u",
            "g",
            "m",
            "v",
            1.165,
            "f",
            "f",
            0,
            "f",
            "s",
            28,
            0,
            "-",
            833257,
        ],
        [
            "b",
            74.83,
            19,
            "y",
            "p",
            "ff",
            "ff",
            0.04,
            "f",
            "t",
            2,
            "f",
            "g",
            0,
            351,
            "-",
            833258,
        ],
        [
            "b",
            28.17,
            0.125,
            "y",
            "p",
            "k",
            "v",
            0.085,
            "f",
            "f",
            0,
            "f",
            "g",
            216,
            2100,
            "-",
            833259,
        ],
        [
            "b",
            24.5,
            13.335,
            "y",
            "p",
            "aa",
            "v",
            0.04,
            "f",
            "f",
            0,
            "t",
            "g",
            120,
            475,
            "-",
            833260,
        ],
        [
            "b",
            18.83,
            3.54,
            "y",
            "p",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "t",
            "g",
            180,
            1,
            "-",
            833261,
        ],
        [
            "?",
            45.33,
            1,
            "u",
            "g",
            "q",
            "v",
            0.125,
            "f",
            "f",
            0,
            "t",
            "g",
            263,
            0,
            "-",
            833262,
        ],
        [
            "a",
            47.25,
            0.75,
            "u",
            "g",
            "q",
            "h",
            2.75,
            "t",
            "t",
            1,
            "f",
            "g",
            333,
            892,
            "+",
            833263,
        ],
        [
            "b",
            24.17,
            0.875,
            "u",
            "g",
            "q",
            "v",
            4.625,
            "t",
            "t",
            2,
            "t",
            "g",
            520,
            2000,
            "+",
            833264,
        ],
        [
            "b",
            39.25,
            9.5,
            "u",
            "g",
            "m",
            "v",
            6.5,
            "t",
            "t",
            14,
            "f",
            "g",
            240,
            4607,
            "+",
            833265,
        ],
        [
            "a",
            20.5,
            11.835,
            "u",
            "g",
            "c",
            "h",
            6,
            "t",
            "f",
            0,
            "f",
            "g",
            340,
            0,
            "+",
            833266,
        ],
        [
            "a",
            18.83,
            4.415,
            "y",
            "p",
            "c",
            "h",
            3,
            "t",
            "f",
            0,
            "f",
            "g",
            240,
            0,
            "+",
            833267,
        ],
        [
            "b",
            19.17,
            9.5,
            "u",
            "g",
            "w",
            "v",
            1.5,
            "t",
            "f",
            0,
            "f",
            "g",
            120,
            2206,
            "+",
            833268,
        ],
        [
            "a",
            25,
            0.875,
            "u",
            "g",
            "x",
            "h",
            1.04,
            "t",
            "f",
            0,
            "t",
            "g",
            160,
            5860,
            "+",
            833269,
        ],
        [
            "b",
            20.17,
            9.25,
            "u",
            "g",
            "c",
            "v",
            1.665,
            "t",
            "t",
            3,
            "t",
            "g",
            40,
            28,
            "+",
            833270,
        ],
        [
            "b",
            25.75,
            0.5,
            "u",
            "g",
            "c",
            "v",
            1.46,
            "t",
            "t",
            5,
            "t",
            "g",
            312,
            0,
            "+",
            833271,
        ],
        [
            "b",
            20.42,
            7,
            "u",
            "g",
            "c",
            "v",
            1.625,
            "t",
            "t",
            3,
            "f",
            "g",
            200,
            1391,
            "+",
            833272,
        ],
        [
            "b",
            "?",
            4,
            "u",
            "g",
            "x",
            "v",
            5,
            "t",
            "t",
            3,
            "t",
            "g",
            290,
            2279,
            "+",
            833273,
        ],
        [
            "b",
            39,
            5,
            "u",
            "g",
            "cc",
            "v",
            3.5,
            "t",
            "t",
            10,
            "t",
            "g",
            0,
            0,
            "+",
            833274,
        ],
        [
            "a",
            64.08,
            0.165,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "t",
            "t",
            1,
            "f",
            "g",
            232,
            100,
            "+",
            833275,
        ],
        [
            "b",
            28.25,
            5.125,
            "u",
            "g",
            "x",
            "v",
            4.75,
            "t",
            "t",
            2,
            "f",
            "g",
            420,
            7,
            "+",
            833276,
        ],
        [
            "a",
            28.75,
            3.75,
            "u",
            "g",
            "c",
            "v",
            1.085,
            "t",
            "t",
            1,
            "t",
            "g",
            371,
            0,
            "+",
            833277,
        ],
        [
            "b",
            31.33,
            19.5,
            "u",
            "g",
            "c",
            "v",
            7,
            "t",
            "t",
            16,
            "f",
            "g",
            0,
            5000,
            "+",
            833278,
        ],
        [
            "a",
            18.92,
            9,
            "u",
            "g",
            "aa",
            "v",
            0.75,
            "t",
            "t",
            2,
            "f",
            "g",
            88,
            591,
            "+",
            833279,
        ],
        [
            "a",
            24.75,
            3,
            "u",
            "g",
            "q",
            "h",
            1.835,
            "t",
            "t",
            19,
            "f",
            "g",
            0,
            500,
            "+",
            833280,
        ],
        [
            "a",
            30.67,
            12,
            "u",
            "g",
            "c",
            "v",
            2,
            "t",
            "t",
            1,
            "f",
            "g",
            220,
            19,
            "+",
            833281,
        ],
        [
            "b",
            21,
            4.79,
            "y",
            "p",
            "w",
            "v",
            2.25,
            "t",
            "t",
            1,
            "t",
            "g",
            80,
            300,
            "+",
            833282,
        ],
        [
            "b",
            13.75,
            4,
            "y",
            "p",
            "w",
            "v",
            1.75,
            "t",
            "t",
            2,
            "t",
            "g",
            120,
            1000,
            "+",
            833283,
        ],
        [
            "a",
            46,
            4,
            "u",
            "g",
            "j",
            "j",
            0,
            "t",
            "f",
            0,
            "f",
            "g",
            100,
            960,
            "+",
            833284,
        ],
        [
            "a",
            44.33,
            0,
            "u",
            "g",
            "c",
            "v",
            2.5,
            "t",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "+",
            833285,
        ],
        [
            "b",
            20.25,
            9.96,
            "u",
            "g",
            "e",
            "dd",
            0,
            "t",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "+",
            833286,
        ],
        [
            "b",
            22.67,
            2.54,
            "y",
            "p",
            "c",
            "h",
            2.585,
            "t",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "+",
            833287,
        ],
        [
            "b",
            "?",
            10.5,
            "u",
            "g",
            "x",
            "v",
            6.5,
            "t",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "+",
            833288,
        ],
        [
            "a",
            60.92,
            5,
            "u",
            "g",
            "aa",
            "v",
            4,
            "t",
            "t",
            4,
            "f",
            "g",
            0,
            99,
            "+",
            833289,
        ],
        [
            "b",
            16.08,
            0.75,
            "u",
            "g",
            "c",
            "v",
            1.75,
            "t",
            "t",
            5,
            "t",
            "g",
            352,
            690,
            "+",
            833290,
        ],
        [
            "a",
            28.17,
            0.375,
            "u",
            "g",
            "q",
            "v",
            0.585,
            "t",
            "t",
            4,
            "f",
            "g",
            80,
            0,
            "+",
            833291,
        ],
        [
            "b",
            39.17,
            1.71,
            "u",
            "g",
            "x",
            "v",
            0.125,
            "t",
            "t",
            5,
            "t",
            "g",
            480,
            0,
            "+",
            833292,
        ],
        [
            "?",
            20.42,
            7.5,
            "u",
            "g",
            "k",
            "v",
            1.5,
            "t",
            "t",
            1,
            "f",
            "g",
            160,
            234,
            "+",
            833293,
        ],
        [
            "a",
            30,
            5.29,
            "u",
            "g",
            "e",
            "dd",
            2.25,
            "t",
            "t",
            5,
            "t",
            "g",
            99,
            500,
            "+",
            833294,
        ],
        [
            "b",
            22.83,
            3,
            "u",
            "g",
            "m",
            "v",
            1.29,
            "t",
            "t",
            1,
            "f",
            "g",
            260,
            800,
            "+",
            833295,
        ],
        [
            "a",
            22.5,
            8.5,
            "u",
            "g",
            "q",
            "v",
            1.75,
            "t",
            "t",
            10,
            "f",
            "g",
            80,
            990,
            "-",
            833296,
        ],
        [
            "a",
            28.58,
            1.665,
            "u",
            "g",
            "q",
            "v",
            2.415,
            "t",
            "f",
            0,
            "t",
            "g",
            440,
            0,
            "-",
            833297,
        ],
        [
            "b",
            45.17,
            1.5,
            "u",
            "g",
            "c",
            "v",
            2.5,
            "t",
            "f",
            0,
            "t",
            "g",
            140,
            0,
            "-",
            833298,
        ],
        [
            "b",
            41.58,
            1.75,
            "u",
            "g",
            "k",
            "v",
            0.21,
            "t",
            "f",
            0,
            "f",
            "g",
            160,
            0,
            "-",
            833299,
        ],
        [
            "a",
            57.08,
            0.335,
            "u",
            "g",
            "i",
            "bb",
            1,
            "t",
            "f",
            0,
            "t",
            "g",
            252,
            2197,
            "-",
            833300,
        ],
        [
            "a",
            55.75,
            7.08,
            "u",
            "g",
            "k",
            "h",
            6.75,
            "t",
            "t",
            3,
            "t",
            "g",
            100,
            50,
            "-",
            833301,
        ],
        [
            "b",
            43.25,
            25.21,
            "u",
            "g",
            "q",
            "h",
            0.21,
            "t",
            "t",
            1,
            "f",
            "g",
            760,
            90,
            "-",
            833302,
        ],
        [
            "a",
            25.33,
            2.085,
            "u",
            "g",
            "c",
            "h",
            2.75,
            "t",
            "f",
            0,
            "t",
            "g",
            360,
            1,
            "-",
            833303,
        ],
        [
            "a",
            24.58,
            0.67,
            "u",
            "g",
            "aa",
            "h",
            1.75,
            "t",
            "f",
            0,
            "f",
            "g",
            400,
            0,
            "-",
            833304,
        ],
        [
            "b",
            43.17,
            2.25,
            "u",
            "g",
            "i",
            "bb",
            0.75,
            "t",
            "f",
            0,
            "f",
            "g",
            560,
            0,
            "-",
            833305,
        ],
        [
            "b",
            40.92,
            0.835,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "t",
            "f",
            0,
            "f",
            "g",
            130,
            1,
            "-",
            833306,
        ],
        [
            "b",
            31.83,
            2.5,
            "u",
            "g",
            "aa",
            "v",
            7.5,
            "t",
            "f",
            0,
            "t",
            "g",
            523,
            0,
            "-",
            833307,
        ],
        [
            "a",
            33.92,
            1.585,
            "y",
            "p",
            "ff",
            "ff",
            0,
            "t",
            "f",
            0,
            "f",
            "g",
            320,
            0,
            "-",
            833308,
        ],
        [
            "a",
            24.92,
            1.25,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "t",
            "f",
            0,
            "f",
            "g",
            80,
            0,
            "-",
            833309,
        ],
        [
            "b",
            35.25,
            3.165,
            "u",
            "g",
            "x",
            "h",
            3.75,
            "t",
            "f",
            0,
            "t",
            "g",
            680,
            0,
            "-",
            833310,
        ],
        [
            "b",
            34.25,
            1.75,
            "u",
            "g",
            "w",
            "bb",
            0.25,
            "t",
            "f",
            0,
            "t",
            "g",
            163,
            0,
            "-",
            833311,
        ],
        [
            "b",
            80.25,
            5.5,
            "u",
            "g",
            "?",
            "?",
            0.54,
            "t",
            "f",
            0,
            "f",
            "g",
            0,
            340,
            "-",
            833312,
        ],
        [
            "b",
            19.42,
            1.5,
            "y",
            "p",
            "cc",
            "v",
            2,
            "t",
            "f",
            0,
            "t",
            "g",
            100,
            20,
            "-",
            833313,
        ],
        [
            "b",
            42.75,
            3,
            "u",
            "g",
            "i",
            "bb",
            1,
            "t",
            "f",
            0,
            "f",
            "g",
            0,
            200,
            "-",
            833314,
        ],
        [
            "b",
            19.67,
            10,
            "y",
            "p",
            "k",
            "h",
            0.835,
            "t",
            "f",
            0,
            "t",
            "g",
            140,
            0,
            "-",
            833315,
        ],
        [
            "b",
            36.33,
            3.79,
            "u",
            "g",
            "w",
            "v",
            1.165,
            "t",
            "f",
            0,
            "t",
            "g",
            200,
            0,
            "-",
            833316,
        ],
        [
            "b",
            30.08,
            1.04,
            "y",
            "p",
            "i",
            "bb",
            0.5,
            "t",
            "t",
            10,
            "t",
            "g",
            132,
            28,
            "-",
            833317,
        ],
        [
            "b",
            44.25,
            11,
            "y",
            "p",
            "d",
            "v",
            1.5,
            "t",
            "f",
            0,
            "f",
            "s",
            0,
            0,
            "-",
            833318,
        ],
        [
            "b",
            23.58,
            0.46,
            "y",
            "p",
            "w",
            "v",
            2.625,
            "t",
            "t",
            6,
            "t",
            "g",
            208,
            347,
            "-",
            833319,
        ],
        [
            "b",
            23.92,
            1.5,
            "u",
            "g",
            "d",
            "h",
            1.875,
            "t",
            "t",
            6,
            "f",
            "g",
            200,
            327,
            "+",
            833320,
        ],
        [
            "b",
            33.17,
            1,
            "u",
            "g",
            "x",
            "v",
            0.75,
            "t",
            "t",
            7,
            "t",
            "g",
            340,
            4071,
            "+",
            833321,
        ],
        [
            "b",
            48.33,
            12,
            "u",
            "g",
            "m",
            "v",
            16,
            "t",
            "f",
            0,
            "f",
            "s",
            110,
            0,
            "+",
            833322,
        ],
        [
            "b",
            76.75,
            22.29,
            "u",
            "g",
            "e",
            "z",
            12.75,
            "t",
            "t",
            1,
            "t",
            "g",
            0,
            109,
            "+",
            833323,
        ],
        [
            "b",
            51.33,
            10,
            "u",
            "g",
            "i",
            "bb",
            0,
            "t",
            "t",
            11,
            "f",
            "g",
            0,
            1249,
            "+",
            833324,
        ],
        [
            "b",
            34.75,
            15,
            "u",
            "g",
            "r",
            "n",
            5.375,
            "t",
            "t",
            9,
            "t",
            "g",
            0,
            134,
            "+",
            833325,
        ],
        [
            "b",
            38.58,
            3.335,
            "u",
            "g",
            "w",
            "v",
            4,
            "t",
            "t",
            14,
            "f",
            "g",
            383,
            1344,
            "+",
            833326,
        ],
        [
            "a",
            22.42,
            11.25,
            "y",
            "p",
            "x",
            "h",
            0.75,
            "t",
            "t",
            4,
            "f",
            "g",
            0,
            321,
            "+",
            833327,
        ],
        [
            "b",
            41.92,
            0.42,
            "u",
            "g",
            "c",
            "h",
            0.21,
            "t",
            "t",
            6,
            "f",
            "g",
            220,
            948,
            "+",
            833328,
        ],
        [
            "b",
            29.58,
            4.5,
            "u",
            "g",
            "w",
            "v",
            7.5,
            "t",
            "t",
            2,
            "t",
            "g",
            330,
            0,
            "+",
            833329,
        ],
        [
            "a",
            32.17,
            1.46,
            "u",
            "g",
            "w",
            "v",
            1.085,
            "t",
            "t",
            16,
            "f",
            "g",
            120,
            2079,
            "+",
            833330,
        ],
        [
            "b",
            51.42,
            0.04,
            "u",
            "g",
            "x",
            "h",
            0.04,
            "t",
            "f",
            0,
            "f",
            "g",
            0,
            3000,
            "+",
            833331,
        ],
        [
            "a",
            22.83,
            2.29,
            "u",
            "g",
            "q",
            "h",
            2.29,
            "t",
            "t",
            7,
            "t",
            "g",
            140,
            2384,
            "+",
            833332,
        ],
        [
            "a",
            25,
            12.33,
            "u",
            "g",
            "cc",
            "h",
            3.5,
            "t",
            "t",
            6,
            "f",
            "g",
            400,
            458,
            "+",
            833333,
        ],
        [
            "b",
            26.75,
            1.125,
            "u",
            "g",
            "x",
            "h",
            1.25,
            "t",
            "f",
            0,
            "f",
            "g",
            0,
            5298,
            "+",
            833334,
        ],
        [
            "b",
            23.33,
            1.5,
            "u",
            "g",
            "c",
            "h",
            1.415,
            "t",
            "f",
            0,
            "f",
            "g",
            422,
            200,
            "+",
            833335,
        ],
        [
            "b",
            24.42,
            12.335,
            "u",
            "g",
            "q",
            "h",
            1.585,
            "t",
            "f",
            0,
            "t",
            "g",
            120,
            0,
            "+",
            833336,
        ],
        [
            "b",
            42.17,
            5.04,
            "u",
            "g",
            "q",
            "h",
            12.75,
            "t",
            "f",
            0,
            "t",
            "g",
            92,
            0,
            "+",
            833337,
        ],
        [
            "a",
            20.83,
            3,
            "u",
            "g",
            "aa",
            "v",
            0.04,
            "t",
            "f",
            0,
            "f",
            "g",
            100,
            0,
            "+",
            833338,
        ],
        [
            "b",
            23.08,
            11.5,
            "u",
            "g",
            "w",
            "h",
            2.125,
            "t",
            "t",
            11,
            "t",
            "g",
            290,
            284,
            "+",
            833339,
        ],
        [
            "a",
            25.17,
            2.875,
            "u",
            "g",
            "x",
            "h",
            0.875,
            "t",
            "f",
            0,
            "f",
            "g",
            360,
            0,
            "+",
            833340,
        ],
        [
            "b",
            43.08,
            0.375,
            "y",
            "p",
            "c",
            "v",
            0.375,
            "t",
            "t",
            8,
            "t",
            "g",
            300,
            162,
            "+",
            833341,
        ],
        [
            "a",
            35.75,
            0.915,
            "u",
            "g",
            "aa",
            "v",
            0.75,
            "t",
            "t",
            4,
            "f",
            "g",
            0,
            1583,
            "+",
            833342,
        ],
        [
            "b",
            59.5,
            2.75,
            "u",
            "g",
            "w",
            "v",
            1.75,
            "t",
            "t",
            5,
            "t",
            "g",
            60,
            58,
            "+",
            833343,
        ],
        [
            "b",
            21,
            3,
            "y",
            "p",
            "d",
            "v",
            1.085,
            "t",
            "t",
            8,
            "t",
            "g",
            160,
            1,
            "+",
            833344,
        ],
        [
            "b",
            21.92,
            0.54,
            "y",
            "p",
            "x",
            "v",
            0.04,
            "t",
            "t",
            1,
            "t",
            "g",
            840,
            59,
            "+",
            833345,
        ],
        [
            "a",
            65.17,
            14,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "t",
            "t",
            11,
            "t",
            "g",
            0,
            1400,
            "+",
            833346,
        ],
        [
            "a",
            20.33,
            10,
            "u",
            "g",
            "c",
            "h",
            1,
            "t",
            "t",
            4,
            "f",
            "g",
            50,
            1465,
            "+",
            833347,
        ],
        [
            "b",
            32.25,
            0.165,
            "y",
            "p",
            "c",
            "h",
            3.25,
            "t",
            "t",
            1,
            "t",
            "g",
            432,
            8000,
            "+",
            833348,
        ],
        [
            "b",
            30.17,
            0.5,
            "u",
            "g",
            "c",
            "v",
            1.75,
            "t",
            "t",
            11,
            "f",
            "g",
            32,
            540,
            "+",
            833349,
        ],
        [
            "b",
            25.17,
            6,
            "u",
            "g",
            "c",
            "v",
            1,
            "t",
            "t",
            3,
            "f",
            "g",
            0,
            0,
            "+",
            833350,
        ],
        [
            "b",
            39.17,
            1.625,
            "u",
            "g",
            "c",
            "v",
            1.5,
            "t",
            "t",
            10,
            "f",
            "g",
            186,
            4700,
            "+",
            833351,
        ],
        [
            "b",
            39.08,
            6,
            "u",
            "g",
            "m",
            "v",
            1.29,
            "t",
            "t",
            5,
            "t",
            "g",
            108,
            1097,
            "+",
            833352,
        ],
        [
            "b",
            31.67,
            0.83,
            "u",
            "g",
            "x",
            "v",
            1.335,
            "t",
            "t",
            8,
            "t",
            "g",
            303,
            3290,
            "+",
            833353,
        ],
        [
            "b",
            41,
            0.04,
            "u",
            "g",
            "e",
            "v",
            0.04,
            "f",
            "t",
            1,
            "f",
            "s",
            560,
            0,
            "+",
            833354,
        ],
        [
            "b",
            48.5,
            4.25,
            "u",
            "g",
            "m",
            "v",
            0.125,
            "t",
            "f",
            0,
            "t",
            "g",
            225,
            0,
            "+",
            833355,
        ],
        [
            "b",
            32.67,
            9,
            "y",
            "p",
            "w",
            "h",
            5.25,
            "t",
            "f",
            0,
            "t",
            "g",
            154,
            0,
            "+",
            833356,
        ],
        [
            "a",
            28.08,
            15,
            "y",
            "p",
            "e",
            "z",
            0,
            "t",
            "f",
            0,
            "f",
            "g",
            0,
            13212,
            "+",
            833357,
        ],
        [
            "b",
            73.42,
            17.75,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "t",
            "f",
            0,
            "t",
            "g",
            0,
            0,
            "+",
            833358,
        ],
        [
            "b",
            64.08,
            20,
            "u",
            "g",
            "x",
            "h",
            17.5,
            "t",
            "t",
            9,
            "t",
            "g",
            0,
            1000,
            "+",
            833359,
        ],
        [
            "b",
            51.58,
            15,
            "u",
            "g",
            "c",
            "v",
            8.5,
            "t",
            "t",
            9,
            "f",
            "g",
            0,
            0,
            "+",
            833360,
        ],
        [
            "b",
            26.67,
            1.75,
            "y",
            "p",
            "c",
            "v",
            1,
            "t",
            "t",
            5,
            "t",
            "g",
            160,
            5777,
            "+",
            833361,
        ],
        [
            "b",
            25.33,
            0.58,
            "u",
            "g",
            "c",
            "v",
            0.29,
            "t",
            "t",
            7,
            "t",
            "g",
            96,
            5124,
            "+",
            833362,
        ],
        [
            "b",
            30.17,
            6.5,
            "u",
            "g",
            "cc",
            "v",
            3.125,
            "t",
            "t",
            8,
            "f",
            "g",
            330,
            1200,
            "+",
            833363,
        ],
        [
            "b",
            27,
            0.75,
            "u",
            "g",
            "c",
            "h",
            4.25,
            "t",
            "t",
            3,
            "t",
            "g",
            312,
            150,
            "+",
            833364,
        ],
        [
            "b",
            23.17,
            0,
            "?",
            "?",
            "?",
            "?",
            0,
            "f",
            "f",
            0,
            "f",
            "p",
            "?",
            0,
            "+",
            833365,
        ],
        [
            "b",
            34.17,
            5.25,
            "u",
            "g",
            "w",
            "v",
            0.085,
            "f",
            "f",
            0,
            "t",
            "g",
            290,
            6,
            "+",
            833366,
        ],
        [
            "b",
            38.67,
            0.21,
            "u",
            "g",
            "k",
            "v",
            0.085,
            "t",
            "f",
            0,
            "t",
            "g",
            280,
            0,
            "+",
            833367,
        ],
        [
            "b",
            25.75,
            0.75,
            "u",
            "g",
            "c",
            "bb",
            0.25,
            "t",
            "f",
            0,
            "f",
            "g",
            349,
            23,
            "+",
            833368,
        ],
        [
            "a",
            46.08,
            3,
            "u",
            "g",
            "c",
            "v",
            2.375,
            "t",
            "t",
            8,
            "t",
            "g",
            396,
            4159,
            "+",
            833369,
        ],
        [
            "a",
            21.5,
            6,
            "u",
            "g",
            "aa",
            "v",
            2.5,
            "t",
            "t",
            3,
            "f",
            "g",
            80,
            918,
            "+",
            833370,
        ],
        [
            "?",
            20.08,
            0.125,
            "u",
            "g",
            "q",
            "v",
            1,
            "f",
            "t",
            1,
            "f",
            "g",
            240,
            768,
            "+",
            833371,
        ],
        [
            "b",
            20.5,
            2.415,
            "u",
            "g",
            "c",
            "v",
            2,
            "t",
            "t",
            11,
            "t",
            "g",
            200,
            3000,
            "+",
            833372,
        ],
        [
            "a",
            29.5,
            0.46,
            "u",
            "g",
            "k",
            "v",
            0.54,
            "t",
            "t",
            4,
            "f",
            "g",
            380,
            500,
            "+",
            833373,
        ],
        [
            "?",
            42.25,
            1.75,
            "y",
            "p",
            "?",
            "?",
            0,
            "f",
            "f",
            0,
            "t",
            "g",
            150,
            1,
            "-",
            833374,
        ],
        [
            "b",
            29.83,
            1.25,
            "y",
            "p",
            "k",
            "v",
            0.25,
            "f",
            "f",
            0,
            "f",
            "g",
            224,
            0,
            "-",
            833375,
        ],
        [
            "b",
            20.08,
            0.25,
            "u",
            "g",
            "q",
            "v",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            200,
            0,
            "-",
            833376,
        ],
        [
            "b",
            23.42,
            0.585,
            "u",
            "g",
            "c",
            "h",
            0.085,
            "t",
            "f",
            0,
            "f",
            "g",
            180,
            0,
            "-",
            833377,
        ],
        [
            "a",
            29.58,
            1.75,
            "y",
            "p",
            "k",
            "v",
            1.25,
            "f",
            "f",
            0,
            "t",
            "g",
            280,
            0,
            "-",
            833378,
        ],
        [
            "b",
            16.17,
            0.04,
            "u",
            "g",
            "c",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "+",
            833379,
        ],
        [
            "b",
            32.33,
            3.5,
            "u",
            "g",
            "k",
            "v",
            0.5,
            "f",
            "f",
            0,
            "t",
            "g",
            232,
            0,
            "-",
            833380,
        ],
        [
            "b",
            "?",
            0.04,
            "y",
            "p",
            "d",
            "v",
            4.25,
            "f",
            "f",
            0,
            "t",
            "g",
            460,
            0,
            "-",
            833381,
        ],
        [
            "b",
            47.83,
            4.165,
            "u",
            "g",
            "x",
            "bb",
            0.085,
            "f",
            "f",
            0,
            "t",
            "g",
            520,
            0,
            "-",
            833382,
        ],
        [
            "b",
            20,
            1.25,
            "y",
            "p",
            "k",
            "v",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            140,
            4,
            "-",
            833383,
        ],
        [
            "b",
            27.58,
            3.25,
            "y",
            "p",
            "q",
            "h",
            5.085,
            "f",
            "t",
            2,
            "t",
            "g",
            369,
            1,
            "-",
            833384,
        ],
        [
            "b",
            22,
            0.79,
            "u",
            "g",
            "w",
            "v",
            0.29,
            "f",
            "t",
            1,
            "f",
            "g",
            420,
            283,
            "-",
            833385,
        ],
        [
            "b",
            19.33,
            10.915,
            "u",
            "g",
            "c",
            "bb",
            0.585,
            "f",
            "t",
            2,
            "t",
            "g",
            200,
            7,
            "-",
            833386,
        ],
        [
            "a",
            38.33,
            4.415,
            "u",
            "g",
            "c",
            "v",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            160,
            0,
            "-",
            833387,
        ],
        [
            "b",
            29.42,
            1.25,
            "u",
            "g",
            "c",
            "h",
            0.25,
            "f",
            "t",
            2,
            "t",
            "g",
            400,
            108,
            "-",
            833388,
        ],
        [
            "b",
            22.67,
            0.75,
            "u",
            "g",
            "i",
            "v",
            1.585,
            "f",
            "t",
            1,
            "t",
            "g",
            400,
            9,
            "-",
            833389,
        ],
        [
            "b",
            32.25,
            14,
            "y",
            "p",
            "ff",
            "ff",
            0,
            "f",
            "t",
            2,
            "f",
            "g",
            160,
            1,
            "-",
            833390,
        ],
        [
            "b",
            29.58,
            4.75,
            "u",
            "g",
            "m",
            "v",
            2,
            "f",
            "t",
            1,
            "t",
            "g",
            460,
            68,
            "-",
            833391,
        ],
        [
            "b",
            18.42,
            10.415,
            "y",
            "p",
            "aa",
            "v",
            0.125,
            "t",
            "f",
            0,
            "f",
            "g",
            120,
            375,
            "-",
            833392,
        ],
        [
            "b",
            22.17,
            2.25,
            "u",
            "g",
            "i",
            "v",
            0.125,
            "f",
            "f",
            0,
            "f",
            "g",
            160,
            10,
            "-",
            833393,
        ],
        [
            "b",
            22.67,
            0.165,
            "u",
            "g",
            "c",
            "j",
            2.25,
            "f",
            "f",
            0,
            "t",
            "s",
            0,
            0,
            "+",
            833394,
        ],
        [
            "a",
            25.58,
            0,
            "?",
            "?",
            "?",
            "?",
            0,
            "f",
            "f",
            0,
            "f",
            "p",
            "?",
            0,
            "+",
            833395,
        ],
        [
            "b",
            18.83,
            0,
            "u",
            "g",
            "q",
            "v",
            0.665,
            "f",
            "f",
            0,
            "f",
            "g",
            160,
            1,
            "-",
            833396,
        ],
        [
            "b",
            21.58,
            0.79,
            "y",
            "p",
            "cc",
            "v",
            0.665,
            "f",
            "f",
            0,
            "f",
            "g",
            160,
            0,
            "-",
            833397,
        ],
        [
            "b",
            23.75,
            12,
            "u",
            "g",
            "c",
            "v",
            2.085,
            "f",
            "f",
            0,
            "f",
            "s",
            80,
            0,
            "-",
            833398,
        ],
        [
            "b",
            22,
            7.835,
            "y",
            "p",
            "i",
            "bb",
            0.165,
            "f",
            "f",
            0,
            "t",
            "g",
            "?",
            0,
            "-",
            833399,
        ],
        [
            "b",
            36.08,
            2.54,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            1000,
            "-",
            833400,
        ],
        [
            "b",
            29.25,
            13,
            "u",
            "g",
            "d",
            "h",
            0.5,
            "f",
            "f",
            0,
            "f",
            "g",
            228,
            0,
            "-",
            833401,
        ],
        [
            "a",
            19.58,
            0.665,
            "u",
            "g",
            "w",
            "v",
            1.665,
            "f",
            "f",
            0,
            "f",
            "g",
            220,
            5,
            "-",
            833402,
        ],
        [
            "a",
            22.92,
            1.25,
            "u",
            "g",
            "q",
            "v",
            0.25,
            "f",
            "f",
            0,
            "t",
            "g",
            120,
            809,
            "-",
            833403,
        ],
        [
            "a",
            27.25,
            0.29,
            "u",
            "g",
            "m",
            "h",
            0.125,
            "f",
            "t",
            1,
            "t",
            "g",
            272,
            108,
            "-",
            833404,
        ],
        [
            "a",
            38.75,
            1.5,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            76,
            0,
            "-",
            833405,
        ],
        [
            "b",
            32.42,
            2.165,
            "y",
            "p",
            "k",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            120,
            0,
            "-",
            833406,
        ],
        [
            "a",
            23.75,
            0.71,
            "u",
            "g",
            "w",
            "v",
            0.25,
            "f",
            "t",
            1,
            "t",
            "g",
            240,
            4,
            "-",
            833407,
        ],
        [
            "b",
            18.17,
            2.46,
            "u",
            "g",
            "c",
            "n",
            0.96,
            "f",
            "t",
            2,
            "t",
            "g",
            160,
            587,
            "-",
            833408,
        ],
        [
            "b",
            40.92,
            0.5,
            "y",
            "p",
            "m",
            "v",
            0.5,
            "f",
            "f",
            0,
            "t",
            "g",
            130,
            0,
            "-",
            833409,
        ],
        [
            "b",
            19.5,
            9.585,
            "u",
            "g",
            "aa",
            "v",
            0.79,
            "f",
            "f",
            0,
            "f",
            "g",
            80,
            350,
            "-",
            833410,
        ],
        [
            "b",
            28.58,
            3.625,
            "u",
            "g",
            "aa",
            "v",
            0.25,
            "f",
            "f",
            0,
            "t",
            "g",
            100,
            0,
            "-",
            833411,
        ],
        [
            "b",
            35.58,
            0.75,
            "u",
            "g",
            "k",
            "v",
            1.5,
            "f",
            "f",
            0,
            "t",
            "g",
            231,
            0,
            "-",
            833412,
        ],
        [
            "b",
            34.17,
            2.75,
            "u",
            "g",
            "i",
            "bb",
            2.5,
            "f",
            "f",
            0,
            "t",
            "g",
            232,
            200,
            "-",
            833413,
        ],
        [
            "?",
            33.17,
            2.25,
            "y",
            "p",
            "cc",
            "v",
            3.5,
            "f",
            "f",
            0,
            "t",
            "g",
            200,
            141,
            "-",
            833414,
        ],
        [
            "b",
            31.58,
            0.75,
            "y",
            "p",
            "aa",
            "v",
            3.5,
            "f",
            "f",
            0,
            "t",
            "g",
            320,
            0,
            "-",
            833415,
        ],
        [
            "a",
            52.5,
            7,
            "u",
            "g",
            "aa",
            "h",
            3,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "-",
            833416,
        ],
        [
            "b",
            36.17,
            0.42,
            "y",
            "p",
            "w",
            "v",
            0.29,
            "f",
            "f",
            0,
            "t",
            "g",
            309,
            2,
            "-",
            833417,
        ],
        [
            "b",
            37.33,
            2.665,
            "u",
            "g",
            "cc",
            "v",
            0.165,
            "f",
            "f",
            0,
            "t",
            "g",
            0,
            501,
            "-",
            833418,
        ],
        [
            "a",
            20.83,
            8.5,
            "u",
            "g",
            "c",
            "v",
            0.165,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            351,
            "-",
            833419,
        ],
        [
            "b",
            24.08,
            9,
            "u",
            "g",
            "aa",
            "v",
            0.25,
            "f",
            "f",
            0,
            "t",
            "g",
            0,
            0,
            "-",
            833420,
        ],
        [
            "b",
            25.58,
            0.335,
            "u",
            "g",
            "k",
            "h",
            3.5,
            "f",
            "f",
            0,
            "t",
            "g",
            340,
            0,
            "-",
            833421,
        ],
        [
            "a",
            35.17,
            3.75,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "t",
            6,
            "f",
            "g",
            0,
            200,
            "-",
            833422,
        ],
        [
            "b",
            48.08,
            3.75,
            "u",
            "g",
            "i",
            "bb",
            1,
            "f",
            "f",
            0,
            "f",
            "g",
            100,
            2,
            "-",
            833423,
        ],
        [
            "a",
            15.83,
            7.625,
            "u",
            "g",
            "q",
            "v",
            0.125,
            "f",
            "t",
            1,
            "t",
            "g",
            0,
            160,
            "-",
            833424,
        ],
        [
            "a",
            22.5,
            0.415,
            "u",
            "g",
            "i",
            "v",
            0.335,
            "f",
            "f",
            0,
            "t",
            "s",
            144,
            0,
            "-",
            833425,
        ],
        [
            "b",
            21.5,
            11.5,
            "u",
            "g",
            "i",
            "v",
            0.5,
            "t",
            "f",
            0,
            "t",
            "g",
            100,
            68,
            "-",
            833426,
        ],
        [
            "a",
            23.58,
            0.83,
            "u",
            "g",
            "q",
            "v",
            0.415,
            "f",
            "t",
            1,
            "t",
            "g",
            200,
            11,
            "-",
            833427,
        ],
        [
            "a",
            21.08,
            5,
            "y",
            "p",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "-",
            833428,
        ],
        [
            "b",
            25.67,
            3.25,
            "u",
            "g",
            "c",
            "h",
            2.29,
            "f",
            "t",
            1,
            "t",
            "g",
            416,
            21,
            "-",
            833429,
        ],
        [
            "a",
            38.92,
            1.665,
            "u",
            "g",
            "aa",
            "v",
            0.25,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            390,
            "-",
            833430,
        ],
        [
            "a",
            15.75,
            0.375,
            "u",
            "g",
            "c",
            "v",
            1,
            "f",
            "f",
            0,
            "f",
            "g",
            120,
            18,
            "-",
            833431,
        ],
        [
            "a",
            28.58,
            3.75,
            "u",
            "g",
            "c",
            "v",
            0.25,
            "f",
            "t",
            1,
            "t",
            "g",
            40,
            154,
            "-",
            833432,
        ],
        [
            "b",
            22.25,
            9,
            "u",
            "g",
            "aa",
            "v",
            0.085,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "-",
            833433,
        ],
        [
            "b",
            29.83,
            3.5,
            "u",
            "g",
            "c",
            "v",
            0.165,
            "f",
            "f",
            0,
            "f",
            "g",
            216,
            0,
            "-",
            833434,
        ],
        [
            "a",
            23.5,
            1.5,
            "u",
            "g",
            "w",
            "v",
            0.875,
            "f",
            "f",
            0,
            "t",
            "g",
            160,
            0,
            "-",
            833435,
        ],
        [
            "b",
            32.08,
            4,
            "y",
            "p",
            "cc",
            "v",
            1.5,
            "f",
            "f",
            0,
            "t",
            "g",
            120,
            0,
            "-",
            833436,
        ],
        [
            "b",
            31.08,
            1.5,
            "y",
            "p",
            "w",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "s",
            160,
            0,
            "-",
            833437,
        ],
        [
            "b",
            31.83,
            0.04,
            "y",
            "p",
            "m",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "-",
            833438,
        ],
        [
            "a",
            21.75,
            11.75,
            "u",
            "g",
            "c",
            "v",
            0.25,
            "f",
            "f",
            0,
            "t",
            "g",
            180,
            0,
            "-",
            833439,
        ],
        [
            "a",
            17.92,
            0.54,
            "u",
            "g",
            "c",
            "v",
            1.75,
            "f",
            "t",
            1,
            "t",
            "g",
            80,
            5,
            "-",
            833440,
        ],
        [
            "b",
            30.33,
            0.5,
            "u",
            "g",
            "d",
            "h",
            0.085,
            "f",
            "f",
            0,
            "t",
            "s",
            252,
            0,
            "-",
            833441,
        ],
        [
            "b",
            51.83,
            2.04,
            "y",
            "p",
            "ff",
            "ff",
            1.5,
            "f",
            "f",
            0,
            "f",
            "g",
            120,
            1,
            "-",
            833442,
        ],
        [
            "b",
            47.17,
            5.835,
            "u",
            "g",
            "w",
            "v",
            5.5,
            "f",
            "f",
            0,
            "f",
            "g",
            465,
            150,
            "-",
            833443,
        ],
        [
            "b",
            25.83,
            12.835,
            "u",
            "g",
            "cc",
            "v",
            0.5,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            2,
            "-",
            833444,
        ],
        [
            "a",
            50.25,
            0.835,
            "u",
            "g",
            "aa",
            "v",
            0.5,
            "f",
            "f",
            0,
            "t",
            "g",
            240,
            117,
            "-",
            833445,
        ],
        [
            "?",
            29.5,
            2,
            "y",
            "p",
            "e",
            "h",
            2,
            "f",
            "f",
            0,
            "f",
            "g",
            256,
            17,
            "-",
            833446,
        ],
        [
            "a",
            37.33,
            2.5,
            "u",
            "g",
            "i",
            "h",
            0.21,
            "f",
            "f",
            0,
            "f",
            "g",
            260,
            246,
            "-",
            833447,
        ],
        [
            "a",
            41.58,
            1.04,
            "u",
            "g",
            "aa",
            "v",
            0.665,
            "f",
            "f",
            0,
            "f",
            "g",
            240,
            237,
            "-",
            833448,
        ],
        [
            "a",
            30.58,
            10.665,
            "u",
            "g",
            "q",
            "h",
            0.085,
            "f",
            "t",
            12,
            "t",
            "g",
            129,
            3,
            "-",
            833449,
        ],
        [
            "b",
            19.42,
            7.25,
            "u",
            "g",
            "m",
            "v",
            0.04,
            "f",
            "t",
            1,
            "f",
            "g",
            100,
            1,
            "-",
            833450,
        ],
        [
            "a",
            17.92,
            10.21,
            "u",
            "g",
            "ff",
            "ff",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            50,
            "-",
            833451,
        ],
        [
            "a",
            20.08,
            1.25,
            "u",
            "g",
            "c",
            "v",
            0,
            "f",
            "f",
            0,
            "f",
            "g",
            0,
            0,
            "-",
            833452,
        ],
        [
            "b",
            19.5,
            0.29,
            "u",
            "g",
            "k",
            "v",
            0.29,
            "f",
            "f",
            0,
            "f",
            "g",
            280,
            364,
            "-",
            833453,
        ],
        [
            "b",
            27.83,
            1,
            "y",
            "p",
            "d",
            "h",
            3,
            "f",
            "f",
            0,
            "f",
            "g",
            176,
            537,
            "-",
            833454,
        ],
        [
            "b",
            17.08,
            3.29,
            "u",
            "g",
            "i",
            "v",
            0.335,
            "f",
            "f",
            0,
            "t",
            "g",
            140,
            2,
            "-",
            833455,
        ],
        [
            "b",
            36.42,
            0.75,
            "y",
            "p",
            "d",
            "v",
            0.585,
            "f",
            "f",
            0,
            "f",
            "g",
            240,
            3,
            "-",
            833456,
        ],
        [
            "b",
            40.58,
            3.29,
            "u",
            "g",
            "m",
            "v",
            3.5,
            "f",
            "f",
            0,
            "t",
            "s",
            400,
            0,
            "-",
            833457,
        ],
        [
            "b",
            21.08,
            10.085,
            "y",
            "p",
            "e",
            "h",
            1.25,
            "f",
            "f",
            0,
            "f",
            "g",
            260,
            0,
            "-",
            833458,
        ],
        [
            "a",
            22.67,
            0.75,
            "u",
            "g",
            "c",
            "v",
            2,
            "f",
            "t",
            2,
            "t",
            "g",
            200,
            394,
            "-",
            833459,
        ],
        [
            "a",
            25.25,
            13.5,
            "y",
            "p",
            "ff",
            "ff",
            2,
            "f",
            "t",
            1,
            "t",
            "g",
            200,
            1,
            "-",
            833460,
        ],
        [
            "b",
            17.92,
            0.205,
            "u",
            "g",
            "aa",
            "v",
            0.04,
            "f",
            "f",
            0,
            "f",
            "g",
            280,
            750,
            "-",
            833461,
        ],
        [
            "b",
            35,
            3.375,
            "u",
            "g",
            "c",
            "h",
            8.29,
            "f",
            "f",
            0,
            "t",
            "g",
            0,
            0,
            "-",
            833462,
        ],
    ],
};
